interface Locale {
  [key: string]: {
    en_US: string;
    ar_SA: string;
    tr_TR: string;
    ru_RU: string;
    uz_UZ: string; // 乌兹别克语
    ur_PK?: string; // 乌尔都语
    pt_BR?: string; // 葡萄牙语(巴西)
    id_ID?: string; // 印度尼西亚语
    fa_IR?: string; // 波斯语
    zh_CN?: string;
    th_TH?: string;
    vi_VN?: string;
    es_ES?: string;
  };
}

const locales: Locale = {
  语言: {
    en_US: 'English',
    ar_SA: 'لغة',
    tr_TR: 'dil',
    pt_BR: 'Idioma',
    id_ID: 'Bahasa',
    ru_RU: 'Язык',
    uz_UZ: 'Til',
    fa_IR: 'زبان',
    ur_PK: 'زبان',
  },
  '请求地址异常，请检查': {
    en_US: 'The request address is abnormal, please check',
    ar_SA: 'عنوان الطلب غير طبيعي، يرجى التحقق',
    tr_TR: 'İstek adresi anormal, lütfen kontrol edin',
    pt_BR: 'O endereço da solicitação é anormal, por favor, verifique',
    id_ID: 'Alamat permintaan tidak normal, silakan periksa',
    ru_RU: 'Адрес запроса некорректен, пожалуйста, проверьте',
    uz_UZ: 'So‘rov manzili g‘ayritabiiy, tekshiring',
    fa_IR: 'آدرس درخواست غیر عادی است، لطفاً بررسی کنید',
    ur_PK: 'درخواست آدرس نامعتبر است، لطفاً تائید کنید',
  },
  '请求网络异常，请稍后': {
    en_US: 'Request network exception, please wait.',
    ar_SA: 'طلب استثناء الشبكة، يرجى الانتظار.',
    tr_TR: 'Ağ istisnası isteyin, lütfen bekleyin.',
    pt_BR: 'Exceção de rede na solicitação, por favor, aguarde.',
    id_ID: 'Jaringan permintaan bermasalah, silakan tunggu.',
    ru_RU: 'Исключение сети запроса, пожалуйста, подождите.',
    uz_UZ: 'So‘rov tarmog‘ida xatolik, iltimos, kuting.',
    fa_IR: 'استثناء شبکه درخواست، لطفاً صبر کنید.',
    ur_PK: 'درخواست اینترنتی خطا دارد، لطفاً منتظر بمانید.',
  },
  请求失败: {
    en_US: 'Request failed',
    ar_SA: 'فشل الطلب',
    tr_TR: 'İstek başarısız oldu',
    pt_BR: 'Solicitação falhou',
    id_ID: 'Permintaan gagal',
    ru_RU: 'Запрос не удался',
    uz_UZ: 'So‘rov muvaffaqiyatsiz bo‘ldi',
    fa_IR: 'درخواست ناموفق بود',
    ur_PK: 'درخواست ناچیز'
  },
  搜索: {
    en_US: 'Search',
    ar_SA: 'يبحث',
    tr_TR: 'Ara',
    pt_BR: 'Pesquisar',
    id_ID: 'Cari',
    ru_RU: 'Поиск',
    uz_UZ: 'Qidirish',
    fa_IR: 'جستجو',
    ur_PK: 'تلاش'
  },
  '搜索姓名/ID': {
    en_US: 'Search for name / ID',
    ar_SA: 'يبحث عن الاسم / الهوية',
    tr_TR: 'Isim / ID aramak',
    pt_BR: 'Pesquise por nome / ID',
    id_ID: 'Cari nama / ID',
    ru_RU: 'Поиск по имени / ID',
    uz_UZ: 'Ism / ID bo‘yicha qidirish',
    fa_IR: 'جستجو بر اساس نام/شناسه',
    ur_PK: 'جستجو براساس نام / شناسه'
  },
  加入: {
    en_US: 'Join',
    ar_SA: 'إنضمام',
    tr_TR: 'Katılmak',
    pt_BR: 'Junte-se',
    id_ID: 'Bergabung',
    ru_RU: 'Присоединиться',
    uz_UZ: 'Qo‘shilish',
    fa_IR: 'عضویت',
    ur_PK: 'پیوستن'
  },
  提示: {
    en_US: 'Tips',
    ar_SA: 'إشعار',
    tr_TR: 'İPUÇLARI',
    pt_BR: 'Dicas',
    id_ID: 'Petunjuk',
    ru_RU: 'Подсказки',
    uz_UZ: 'Maslahatlar',
    fa_IR: 'راهنماها',
    ur_PK: 'نکات'
  },
  已同意: {
    en_US: 'Agreed',
    ar_SA: 'موافق',
    tr_TR: 'Onaylandı',
    pt_BR: 'Acordado',
    id_ID: 'Disetujui',
    ru_RU: 'Согласовано',
    uz_UZ: 'Qabul qilindi',
    fa_IR: 'تایید شده',
    ur_PK: 'اتفاق کیا۔'
  },
  已拒绝: {
    en_US: 'Rejected',
    ar_SA: 'مرفوض',
    tr_TR: 'Reddedildi',
    pt_BR: 'Rejeitado',
    id_ID: 'Ditolak',
    ru_RU: 'Отклонено',
    uz_UZ: 'Rad etildi',
    fa_IR: 'رد شده',
    ur_PK: 'مسترد'
  },
  拒绝: {
    en_US: 'Refuse',
    ar_SA: 'يرفض',
    tr_TR: 'Reddet',
    pt_BR: 'Recusar',
    id_ID: 'Tolak',
    ru_RU: 'Отклонить',
    uz_UZ: 'Rad etish',
    fa_IR: 'رد کردن',
    ur_PK: 'انکار'
  },
  同意: {
    en_US: 'Agree',
    ar_SA: 'موافقة',
    tr_TR: 'Onayla',
    pt_BR: 'Aceitar',
    id_ID: 'Setuju',
    ru_RU: 'Согласиться',
    uz_UZ: 'Rozilik bildirish',
    fa_IR: 'تایید کردن',
    ur_PK: 'متفق '
  },
  会员: {
    en_US: 'Member',
    ar_SA: 'عضو',
    tr_TR: 'Üye',
    pt_BR: 'Membro',
    id_ID: 'Anggota',
    ru_RU: 'Член',
    uz_UZ: "A'zo",
    fa_IR: 'عضو',
    ur_PK: 'ممبر'
  },
  '邀请': {
    en_US: 'Invite',
    ar_SA: 'مشاركة',
    tr_TR: 'davet et',
    pt_BR: 'Convidar',
    id_ID: 'Undang',
    ru_RU: 'Пригласить',
    uz_UZ: 'Taklif qilish',
    fa_IR: 'دعوت',
    ur_PK: 'دعوت دیں'
  },
  '没有更多了': {
    en_US: 'No more',
    ar_SA: 'لا يوجد المزيد',
    tr_TR: 'Daha fazla yok',
    pt_BR: 'Não há mais',
    id_ID: 'Tidak ada lagi',
    ru_RU: 'Больше нет',
    uz_UZ: 'Boshqa narsa yo‘q',
    fa_IR: 'دیگر چیزی وجود ندارد',
    ur_PK: 'مزید کچھ نہیں'
  },
  '同意成功': {
    en_US: 'Agree successfully',
    ar_SA: 'تم الموافقة بنجاح',
    tr_TR: 'Kabul edildi',
    pt_BR: 'Aceito com sucesso',
    id_ID: 'Disetujui berhasil',
    ru_RU: 'Успешно согласовано',
    uz_UZ: 'Muvaffaqiyatli tasdiqlandi',
    fa_IR: 'تایید با موفقیت انجام شد',
    ur_PK: 'کامیابی سے منظور'
  },
  '拒绝成功': {
    en_US: 'Reject successfully',
    ar_SA: 'تم الرفض بنجاح',
    tr_TR: 'Reddedildi',
    pt_BR: 'Rejeitado com sucesso',
    id_ID: 'Ditolak berhasil',
    ru_RU: 'Успешно отклонено',
    uz_UZ: 'Muvaffaqiyatli rad etildi',
    fa_IR: 'رد با موفقیت انجام شد',
    ur_PK: 'کامیابی سے مسترد'
  },
  该ID不存在: {
    "en_US": "This ID doesn’t exist.",
    "ar_SA": "هذا الايدي ليس موجودا",
    "tr_TR": "ID mevcut değil",
    "pt_BR": "Este ID não existe.",
    "id_ID": "ID ini tidak ada.",
    "ru_RU": "Этот ID не существует.",
    "uz_UZ": "Ushbu ID mavjud emas.",
    "fa_IR": "این ایدی وجود ندارد",
    ur_PK: 'یہ ID موجود نہیں ہے',
  },
  不能为空: {
    "en_US": "Cannot be empty",
    "ar_SA": "لا يمكن أن تكون فارغة",
    "tr_TR": "Boş olamaz",
    "pt_BR": "Não pode ser vazio",
    "id_ID": "Tidak boleh kosong",
    "ru_RU": "Не может быть пустым",
    "uz_UZ": "To‘xtatilmagan",
    "fa_IR": "نمی‌تواند خالی باشد",
    ur_PK: 'خالی نہیں ہو سکتا'
  },
  查询: {
    "en_US": "Check",
    "ar_SA": "التحقيق",
    "tr_TR": "Sorgula",
    "pt_BR": "Verificar",
    "id_ID": "Verifikasi",
    "ru_RU": "Проверить",
    "uz_UZ": "Tasdiqlash",
    "fa_IR": "تایید",
    ur_PK: 'تصدیق کریں'
  },
  热门: {
    "en_US": "Hot",
    "ar_SA": "شائع",
    "tr_TR": "Popüler",
    "pt_BR": "Popular",
    "id_ID": "Populer",
    "ru_RU": "Популярные",
    "uz_UZ": "Popular",
    "fa_IR": "پربازدیده",
    ur_PK: 'مشہور',
  },
  所有: {
    "en_US": "All",
    "ar_SA": "جميع",
    "tr_TR": "Tümü",
    "pt_BR": "Todos",
    "id_ID": "Semua",
    "ru_RU": "Все",
    "uz_UZ": "Hammasi",
    "fa_IR": "همه",
    ur_PK: 'تمام'
  },
  帮助: {
    "en_US": "Help",
    "ar_SA": "ساعد",
    "tr_TR": "yardım",
    "pt_BR": "Ajuda",
    "id_ID": "Bantuan",
    "ru_RU": "Помощь",
    "uz_UZ": "Yordam",
    "fa_IR": "راهنما",
    ur_PK: 'مدد',
  },
  请选择国家: {
    "en_US": "Please select a country",
    "ar_SA": "رجاء قم بإختيار دوله",
    "tr_TR": "Lütfen bir ülke seçin",
    "pt_BR": "Por favor, selecione um país",
    "id_ID": "Silakan pilih negara",
    "ru_RU": "Пожалуйста, выберите страну",
    "uz_UZ": "Tilni tanlang",
    "fa_IR": "لطفاً دلیلی را انتخاب کنید",
    ur_PK: 'براہ کرم ملک منتخب کریں',
  },
  请选择支付方式: {
    "en_US": "Please select mode of payment",
    "ar_SA": "الرجاء تحديد طريقة الدفع",
    "tr_TR": "Lütfen ödeme yöntemini seçin",
    "pt_BR": "Por favor, selecione o modo de pagamento",
    "id_ID": "Silakan pilih metode pembayaran",
    "ru_RU": "Пожалуйста, выберите способ оплаты",
    "uz_UZ": "To‘lov uslubi tanlang",
    "fa_IR": "لطفاً روش پرداخت را انتخاب کنید",
    ur_PK: 'براہ کرم ادائیگی کا طریقہ منتخب کریں',
  },
  请选择充值金额: {
    "en_US": "Please enter the recharge amount",
    "ar_SA": "الرجاء إدخال مبلغ إعادة الشحن",
    "tr_TR": "Lütfen yükleme tutarını girin",
    "pt_BR": "Por favor, insira o valor da recarga",
    "id_ID": "Silakan masukkan jumlah isi ulang",
    "ru_RU": "Пожалуйста, введите сумму пополнения",
    "uz_UZ": "Pulni qo‘shish miqdorida kiriting",
    "fa_IR": "لطفاً مبلغی که می‌خواهید شارژ کنید را وارد کنید",
    ur_PK: 'براہ کرم ریچارج کی رقم درج کریں'
  },
  请选择同意条款: {
    "en_US": "Please agree to the terms",
    "ar_SA": "الرجاء الموافقة على الشروط",
    "tr_TR": "Lütfen şartları kabul etmeyi seçin",
    "pt_BR": "Por favor, concorde com os termos",
    "id_ID": "Silakan setujui syarat dan ketentuan",
    "ru_RU": "Пожалуйста, подтвердите условия",
    "uz_UZ": "Shartnomani qabul qilishga ruxsat berish",
    "fa_IR": "لطفاً شرایط را موافقت کنید",
    ur_PK: 'براہ کرم شرائط سے اتفاق کریں'
  },
  成功: {
    "en_US": "The operation was successful",
    "ar_SA": "العملية كانت ناجحه",
    "tr_TR": "İşlem Başarılı Oldu",
    "pt_BR": "A operação foi bem-sucedida",
    "id_ID": "Operasi berhasil",
    "ru_RU": "Операция выполнена успешно",
    "uz_UZ": "Operatsiya muvaffaqiyatli amalga oshirildi",
    "fa_IR": "عملیات موفقیت آمیز بود",
    ur_PK: 'عمل کامیابی سے مکمل ہوا'
  },
  登录: {
    en_US: "Log in",
    ar_SA: "تسجيل الدخول",
    tr_TR: "Giriş Yap",
    pt_BR: "Entrar",
    id_ID: "Masuk",
    ru_RU: "Войти",
    uz_UZ: "Kirish",
    fa_IR: "ورود",
    ur_PK: "لاگ ان کریں"
  },
  用户名: {
    en_US: "UserName",
    ar_SA: "اسم المستخدم",
    tr_TR: "Kullanıcı Adı",
    pt_BR: "Nome de Usuário",
    id_ID: "Nama Pengguna",
    ru_RU: "Имя пользователя",
    uz_UZ: "Ism-manzil",
    fa_IR: "نام کاربری",
    ur_PK: "صارف کا نام"
  },
  用户名不能为空: {
    en_US: "User name cannot be empty",
    ar_SA: "اسم المستخدم لا يمكن ان يكون فارغ",
    tr_TR: "Kullanıcı adı boş olamaz",
    pt_BR: "O nome de usuário não pode ser vazio",
    id_ID: "Nama pengguna tidak boleh kosong",
    ru_RU: "Имя пользователя не может быть пустым",
    uz_UZ: "Ism-manzil to‘xtatilmagan",
    fa_IR: "نام کاربری نمی‌تواند خالی باشد",
    ur_PK: "صارف کا نام خالی نہیں ہو سکتا"
  },
  密码: {
    en_US: "Password",
    ar_SA: "كلمة المرور",
    tr_TR: "Parola",
    pt_BR: "Senha",
    id_ID: "Kata Sandi",
    ru_RU: "Пароль",
    uz_UZ: "Parol",
    fa_IR: "رمز عبور",
    ur_PK: "پاس ورڈ"
  },
  密码不能为空: {
    en_US: "Password cannot be empty",
    ar_SA: "كلمة المرور لا يمكن ان تكون فارغة",
    tr_TR: "Şifre boş olamaz",
    pt_BR: "A senha não pode ser vazia",
    id_ID: "Kata sandi tidak boleh kosong",
    ru_RU: "Пароль не может быть пустым",
    uz_UZ: "Parol to‘xtatilmagan",
    fa_IR: "رمز عبور نمی‌تواند خالی باشد",
    ur_PK: "پاس ورڈ خالی نہیں ہو سکتا"
  },
  支付: {
    en_US: 'Payment',
    ar_SA: 'دفع',
    tr_TR: 'Ödeme',
    pt_BR: 'Pagamento',
    id_ID: 'Pembayaran',
    ru_RU: 'Оплата',
    uz_UZ: 'To‘lov',
    fa_IR: 'پرداخت',
    ur_PK: 'ادائیگی'
  },
  支付成功: {
    en_US: 'Payment successful',
    ar_SA: 'تم الدفع بنجاح',
    tr_TR: 'Ödeme başarılı',
    pt_BR: 'Pagamento bem-sucedido',
    id_ID: 'Pembayaran berhasil',
    ru_RU: 'Оплата прошла успешно',
    uz_UZ: 'To‘lov muvaffaqiyatli',
    fa_IR: 'پرداخت موفق',
    ur_PK: 'ادائیگی کامیاب'
  },
  处理中: {
    en_US: 'Processing',
    ar_SA: 'قيد المعالجة',
    tr_TR: 'İşleniyor',
    pt_BR: 'Processando',
    id_ID: 'Sedang diproses',
    ru_RU: 'Обрабатывается',
    uz_UZ: 'Bajarilmoqda',
    fa_IR: 'در حال انجام',
    ur_PK: 'پروسیسنگ'
  },
  支付失败: {
    en_US: 'Payment failed',
    ar_SA: 'فشل الدفع',
    tr_TR: 'Ödeme başarısız',
    pt_BR: 'Pagamento falhou',
    id_ID: 'Pembayaran gagal',
    ru_RU: 'Оплата не удалась',
    uz_UZ: 'To‘lov muvaffaqiyatsiz',
    fa_IR: 'پرداخت ناموفق',
    ur_PK: 'ادائیگی ناکام'
  },
  订单关闭: {
    en_US: 'Order closed',
    ar_SA: 'تم إغلاق الطلب',
    tr_TR: 'Sipariş kapatıldı',
    pt_BR: 'Pedido fechado',
    id_ID: 'Pesanan ditutup',
    ru_RU: 'Заказ закрыт',
    uz_UZ: 'Buyurtma qutsuq',
    fa_IR: 'سفارش بسته شد',
    ur_PK: 'آرڈر بند'
  },
  支付金额: {
    en_US: 'Payment amount',
    ar_SA: 'مبلغ الدفع',
    tr_TR: 'Ödeme miktarı',
    pt_BR: 'Valor do pagamento',
    id_ID: 'Jumlah pembayaran',
    ru_RU: 'Сумма оплаты',
    uz_UZ: 'To‘lov miqdori',
    fa_IR: 'مبلغ پرداخت',
    ur_PK: 'ادائیگی کی رقم'
  },
  获得金币: {
    en_US: 'Get coins',
    ar_SA: 'الحصول على العملات',
    tr_TR: 'Altın kazan',
    pt_BR: 'Obter moedas',
    id_ID: 'Dapatkan koin',
    ru_RU: 'Получить монеты',
    uz_UZ: 'Koinni olish',
    fa_IR: 'دریافت ارز',
    ur_PK: 'سکے حاصل کریں'
  },
  付款编号: {
    en_US: 'Payment No.',
    ar_SA: 'رقم الدفع',
    tr_TR: 'Ödeme numarası',
    pt_BR: 'Número do pagamento',
    id_ID: 'Nomor pembayaran',
    ru_RU: 'Номер платежа',
    uz_UZ: 'To‘lov raqami',
    fa_IR: 'شماره پرداخت',
    ur_PK: 'ادائیگی نمبر'
  },
  订单编号: {
    en_US: 'Order No.',
    ar_SA: 'رقم الطلب',
    tr_TR: 'Sipariş numarası',
    pt_BR: 'Número do pedido',
    id_ID: 'Nomor pesanan',
    ru_RU: 'Номер заказа',
    uz_UZ: 'Buyurtma raqami',
    fa_IR: 'شماره سفارش',
    ur_PK: 'آرڈر نمبر'
  },
  返回充值: {
    en_US: 'Back to Recharge',
    ar_SA: 'العودة للشحن',
    tr_TR: 'Yükleme sayfası Geri Dön',
    pt_BR: 'Voltar para recarga',
    id_ID: 'Kembali ke isi ulang',
    ru_RU: 'Вернуться к пополнению',
    uz_UZ: 'Qayta to‘lov',
    fa_IR: 'بازگشت به شارژ',
    ur_PK: 'ریچارج پر واپس جائیں'
  },
  联系客服: {
    en_US: 'Contact Customer Service',
    ar_SA: 'اتصل بخدمة العملاء',
    tr_TR: 'Müşteri Hizmetleri ile iletişime geçin',
    pt_BR: 'Contate o atendimento ao cliente',
    id_ID: 'Hubungi layanan pelanggan',
    ru_RU: 'Свяжитесь с службой поддержки',
    uz_UZ: 'Biz bilan aloqa',
    fa_IR: 'تماس با سرویس های پشتیبانی',
    ur_PK: 'کسٹمر سروس سے رابطہ کریں'
  },
  知道了: {
    en_US: 'Got it',
    ar_SA: 'حسنا',
    tr_TR: 'Anladım',
    pt_BR: 'Entendi',
    id_ID: 'Mengerti',
    ru_RU: 'Понял',
    uz_UZ: 'Aniq',
    fa_IR: 'فهمیدم',
    ur_PK: 'سمجھ گیا'
  },
  复制: {
    en_US: 'Copy',
    ar_SA: 'نسخ',
    tr_TR: 'Kopyala',
    pt_BR: 'Copiar',
    id_ID: 'Salin',
    ru_RU: 'Копировать',
    uz_UZ: 'Nusxalash',
    fa_IR: 'کپی',
    ur_PK: 'نقل کریں'
  },
  详情: {
    en_US: 'Details',
    ar_SA: 'تفاصيل',
    tr_TR: 'Ayrıntılar',
    pt_BR: 'Detalhes',
    id_ID: 'Rincian',
    ru_RU: 'Подробности',
    uz_UZ: 'Ma\'lumotlar',
    fa_IR: 'جزئیات',
    ur_PK: 'تفصیلات'
  },
  今日: {
    en_US: 'Today',
    ar_SA: 'اليوم',
    tr_TR: 'Bugün',
    id_ID: 'Hari Ini',
    pt_BR: 'Hoje',
    ru_RU: 'Сегодня',
    uz_UZ: 'Bugun',
    fa_IR: 'امروز',
    ur_PK: 'آج'
  },
  昨日: {
    en_US: 'Yesterday',
    tr_TR: 'Dün',
    ar_SA: 'امس',
    id_ID: 'Kemarin',
    pt_BR: 'Ontem',
    ru_RU: 'Вчера',
    uz_UZ: 'Kecha',
    fa_IR: 'پیش',
    ur_PK: 'کل'
  },
  本周: {
    en_US: 'This Week',
    tr_TR: 'Bu hafta',
    ar_SA: 'الأسبوع الحالي',
    id_ID: 'Minggu Ini',
    pt_BR: 'Esta Semana',
    ru_RU: 'На этой неделе',
    uz_UZ: 'Bu hafta',
    fa_IR: 'هفته اینجا',
    ur_PK: 'اس ہفتہ'
  },
  上周: {
    en_US: 'Last Week',
    tr_TR: 'Geçen hafta',
    ar_SA: 'الأسبوع الماضي',
    id_ID: 'Minggu Lalu',
    pt_BR: 'Semana Passada',
    ru_RU: 'Прошлая неделя',
    uz_UZ: 'O‘tgan hafta',
    fa_IR: 'هفته گذشته',
    ur_PK: 'گزشتہ ہفتہ'
  },
  本月: {
    en_US: 'This Month',
    tr_TR: 'Bu Ay',
    ar_SA: 'الشهر الحالي',
    id_ID: 'Bulan Ini',
    pt_BR: 'Este Mês',
    ru_RU: 'В этом месяце',
    uz_UZ: 'Bu oy',
    fa_IR: 'این ماه',
    ur_PK: 'اس مہینہ'
  },
  上月: {
    en_US: 'Last Month',
    tr_TR: 'Geçen ay',
    ar_SA: 'الشهر الماضي',
    id_ID: 'Bulan Lalu',
    pt_BR: 'Mês Passado',
    ru_RU: 'Прошлый месяц',
    uz_UZ: 'O‘tgan oy',
    fa_IR: 'ماه گذشته',
    ur_PK: 'گزشتہ مہینہ'
  },
  小时: {
    en_US: 'Hours',
    tr_TR: 'Saatler',
    ar_SA: 'ساعد',
    id_ID: 'Jam',
    pt_BR: 'Horas',
    ru_RU: 'Часы',
    uz_UZ: 'Soatlar',
    fa_IR: 'ساعت',
    ur_PK: 'گھنٹے'
  },
  分钟: {
    en_US: 'Minutes',
    tr_TR: 'Dakikalar',
    ar_SA: 'دقيقد',
    id_ID: 'Menit',
    pt_BR: 'Minutos',
    ru_RU: 'Минуты',
    uz_UZ: 'Daqiqalar',
    fa_IR: 'دقیقه',
    ur_PK: 'منٹ'
  },
  秒: {
    en_US: 'Seconds',
    tr_TR: 'Saniyeler',
    ar_SA: 'ثانية',
    id_ID: 'Detik',
    pt_BR: 'Segundos',
    ru_RU: 'Секунды',
    uz_UZ: 'Soniyalar',
    fa_IR: 'ثانیه',
    ur_PK: 'سیکنڈ'
  },
  utc_tips: {
    zh_CN: '基于Utc+3 时区统计数据',
    en_US: 'Based on Utc+3 time zone statistics',
    tr_TR: 'Utc+3 saat dilimi istatistiklerine göre',
    ar_SA: 'استنادًا إلى إحصائيات المنطقة الزمنية Utc+3',
    id_ID: 'Berdasarkan statistik zona waktu Utc+3',
    pt_BR: 'Com base nas estatísticas de fuso horário UTC+3',
    ru_RU: 'На основе статистики часовых поясов Utc+3',
    uz_UZ: 'UTC+3 vaqt zonalari statistikasi asosida',
    fa_IR: 'سنسورهای زمانی بر پایه Utc+3',
    ur_PK: 'Utc+3 ٹائم زون کے اعداد و شمار پر مبنی'
  },
  举报: {
    zh_CN: '举报',
    en_US: 'Report',
    tr_TR: 'Raporla',
    ar_SA: 'التبليغ',
    id_ID: 'Laporkan',
    pt_BR: 'Denunciar',
    ru_RU: 'Пожаловаться',
    uz_UZ: 'Shikoyat',
    fa_IR: 'گزارش',
    ur_PK: 'گزارش کریں'
  },
  举报类型: {
    zh_CN: '举报类型',
    en_US: 'Report Type',
    tr_TR: 'Rapor Türü',
    ar_SA: 'نوع التبليغ',
    id_ID: 'Jenis laporan',
    pt_BR: 'Tipo de denúncia',
    ru_RU: 'Тип жалобы',
    uz_UZ: 'Shikoyat turini',
    fa_IR: 'نوع گزارش',
    ur_PK: 'گزارش کی ترتیب'
  },
  描述: {
    zh_CN: '描述',
    en_US: 'Description',
    tr_TR: 'Açıklama',
    ar_SA: 'الوصف',
    id_ID: 'Deskripsi',
    pt_BR: 'Descrição',
    ru_RU: 'Описание',
    uz_UZ: 'Ma\'lumot',
    fa_IR: 'توضیحات',
    ur_PK: 'تفصیلات'
  },
  色情: {
    zh_CN: '色情',
    en_US: 'pornography',
    ar_SA: 'التخييم',
    tr_TR: 'Pornografi',
    pt_BR: 'Pornografia',
    id_ID: 'Pornografi',
    ru_RU: 'Порнография',
    uz_UZ: 'Pornografiya',
    fa_IR: 'پرونوگرافی',
    ur_PK: 'پرونوگرافی'
  },
  宗教: {
    zh_CN: '宗教',
    en_US: 'Religion',
    ar_SA: 'الدين',
    tr_TR: 'Din',
    pt_BR: 'Religião',
    id_ID: 'Agama',
    ru_RU: 'Религия',
    uz_UZ: 'Din',
    fa_IR: 'دین',
    ur_PK: 'دین'
  },
  政治: {
    zh_CN: '政治',
    en_US: 'Politics',
    ar_SA: 'السياسة',
    tr_TR: 'Siyaset',
    pt_BR: 'Política',
    id_ID: 'Politik',
    ru_RU: 'Политика',
    uz_UZ: 'Siyosat',
    fa_IR: 'سیاسی',
    ur_PK: 'سیاسی'
  },
  其他: {
    zh_CN: '其他',
    en_US: 'Other',
    ar_SA: 'أخرى',
    tr_TR: 'Diger',
    pt_BR: 'Outro',
    id_ID: 'Lain-lain',
    ru_RU: 'Другое',
    uz_UZ: 'Boshqa',
    fa_IR: 'سایر',
    ur_PK: 'سایر'
  },
  descriptionDetail: {
    zh_CN: '请详细描述具体情况',
    en_US: 'Please provide more details',
    ar_SA: 'يرجى توفر تفاصيل أكثر',
    tr_TR: 'Lütfen daha ayrıntılı bilgi verin',
    pt_BR: 'Por favor, forneça mais detalhes',
    id_ID: 'Silakan berikan informasi lebih lanjut',
    ru_RU: 'Пожалуйста, укажите дополнительную информацию',
    uz_UZ: 'Qizilmalarni to\'liq tasdiqlang',
    fa_IR: 'لطفا اطلاعات بیشتری را به اشتراک بگذارید',
    ur_PK: 'کمزور کرنے کے لئے مزید تفصیلات اپ کیا گیا ہے'
  },
  提交: {
    zh_CN: '提交',
    en_US: 'Submit',
    ar_SA: 'تسجيل',
    tr_TR: 'Gönder',
    pt_BR: 'Enviar',
    id_ID: 'Mengirim',
    ru_RU: 'Отправить',
    uz_UZ: 'Jo\'natish',
    fa_IR: 'ثبت',
    ur_PK: 'تسلیم کریں'
  },
  请选择举报类型: {
    zh_CN: '请选择举报类型',
    en_US: 'Please select report type',
    ar_SA: 'يرجى تحديد نوع التبليغ',
    tr_TR: 'Lütfen rapor türünü seçin',
    pt_BR: 'Por favor, selecione o tipo de denúncia',
    id_ID: 'Silakan pilih jenis laporan',
    ru_RU: 'Пожалуйста, выберите тип жалобы',
    uz_UZ: 'Iltimos, shikoyat turini tanlang',
    fa_IR: 'لطفا نوع گزارش را انتخاب کنید',
    ur_PK: 'لطفا گزارش کی ترتیب را انتخاب کریں'
  },
  操作成功: {
    zh_CN: '操作成功',
    en_US: 'Operation successful',
    ar_SA: 'تمت العملية',
    tr_TR: 'İşlem başarılı',
    pt_BR: 'Operação bem sucedida',
    id_ID: 'Operasi berhasil',
    ru_RU: 'Операция выполнена',
    uz_UZ: 'Operatsiya muvaffaqiyatli amalga oshdi',
    fa_IR: 'عملیات موفقیت آمیز شد',
    ur_PK: 'عملیات کامیاب انجام شد'
  },
  财富: {
    zh_CN: '财富',
    en_US: 'Wealth',
    ar_SA: 'الأثر',
    tr_TR: 'Günlük Gelir',
    pt_BR: 'Renda',
    id_ID: 'Keuangan',
    ru_RU: 'Денежные средства',
    uz_UZ: 'Maliyet',
    fa_IR: 'اقتصاد',
    ur_PK: 'اقتصادیات'
  },
  魅力: {
    zh_CN: '魅力',
    en_US: 'Charm',
    ar_SA: 'الجمال',
    tr_TR: 'Güzellik',
    pt_BR: 'Beleza',
    id_ID: 'Keindahan',
    ru_RU: 'Внешность',
    uz_UZ: 'Ko\'rsatish',
    fa_IR: 'جمال',
    ur_PK: 'جمال'
  },
  '只有<b>{{n}}</b>%的用户达到了这个级别': {
    zh_CN: '只有 <b>{{n}}</b>% 的用户达到了这个级别',
    en_US: 'Only <b>{{n}}</b>% of users reached this level',
    ar_SA: 'فقط <b>{{n}}</b>٪ من المستخدمين اختيار هذا النمط',
    tr_TR: 'Sadece <b>{{n}}</b>% kullanıcı bu seviyeye ulaştı',
    pt_BR: 'Apenas <b>{{n}}</b>% dos usuários alcançaram este nível',
    id_ID: 'Hanya <b>{{n}}</b>% pengguna yang mencapai tahap ini',
    ru_RU: 'Только <b>{{n}}</b>% пользователей достиг этого уровня',
    uz_UZ: 'Faqat <b>{{n}}</b>% foydalanuvchilar bu yutuqlarga qabul qilgan',
    fa_IR: 'فقط <b>{{n}}</b>٪ کاربران این مقام را انجام دادند',
    ur_PK: 'فقط <b>{{n}}</b>٪ کاربر این مقام را انجام دادی'
  },
  当前级别权限: {
    zh_CN: '当前级别权限',
    en_US: 'Current Level Permissions',
    ar_SA: 'صلاحيات نمط حالي',
    tr_TR: 'Mevcut Seviye İzinleri',
    pt_BR: 'Permissões do Nível Atual',
    id_ID: 'Izin Sekarang',
    ru_RU: 'Разрешения текущего уровня',
    uz_UZ: 'O‘zgaruvchilarni baholash',
    fa_IR: 'مجوزات مقام فعلی',
    ur_PK: 'جاری مقام کی حصائیات'
  },
  所有级别奖牌: {
    zh_CN: '所有级别奖牌',
    en_US: 'All Level Awards',
    ar_SA: 'جوائز الكل',
    tr_TR: 'Tüm Seviye Ödüller',
    pt_BR: 'Prêmios de Todos os Níveis',
    id_ID: 'Hadiah Semua Tingkat',
    ru_RU: 'Все награды уровней',
    uz_UZ: 'Barcha yutuqlar',
    fa_IR: 'جوایز هر مقام',
    ur_PK: 'جوائز کل مقام'
  },
  如何升级: {
    zh_CN: '如何升级',
    en_US: 'How to Upgrade',
    ar_SA: 'كيفية الترقية',
    tr_TR: 'Nasıl Yükseltirilir',
    pt_BR: 'Como Atualizar',
    id_ID: 'Cara Mengupgrade',
    ru_RU: 'Как повысить уровень',
    uz_UZ: 'Yutuqlarni tayyorlash',
    fa_IR: 'نحوه ارتقا',
    ur_PK: 'نحوه ترقیع'
  },
  送礼物: {
    zh_CN: '送礼物',
    en_US: 'Send Gift',
    ar_SA: 'إرسال جوائز',
    tr_TR: 'Hediye Çek',
    pt_BR: 'Enviar Presente',
    id_ID: 'Mengirim Hadiah',
    ru_RU: 'Подарить подарок',
    uz_UZ: 'Yetkazib berish',
    fa_IR: 'پیشنهاد دادن',
    ur_PK: 'پیشنهاد دیں'
  },
  收礼物: {
    zh_CN: '收礼物',
    en_US: 'Receive Gift',
    ar_SA: 'استلام جوائز',
    tr_TR: 'Hediye Al',
    pt_BR: 'Receber Presente',
    id_ID: 'Menerima Hadiah',
    ru_RU: 'Получить подарок',
    uz_UZ: 'Yetkazib berish',
    fa_IR: 'پیشنهاد رسیدگی',
    ur_PK: 'پیشنهاد رسیدگی'
  },
  '普通礼物100金币={{n}}Exp': {
    zh_CN: '普通礼物100金币={{n}}Exp',
    en_US: 'Common Gift 100 Coins={{n}}Exp',
    ar_SA: 'جوائز عادية 100 طلبة نقدية={{n}}Exp',
    tr_TR: 'Genel Hediye 100 Gümüş Mübarek={{n}}Exp',
    pt_BR: 'Presente Comum 100 Moedas de Ouro={{n}}Exp',
    id_ID: 'Hadiah Umum 100 Koin Emas={{n}}Exp',
    ru_RU: 'Обычный подарок 100 золотых монет={{n}}Exp',
    uz_UZ: "Umumiy yetkazib 100 so'mlik kupon={{n}}Exp",
    fa_IR: 'پیشنهاد عادی 100 گلدان={{n}}Exp',
    ur_PK: 'عادی پیشنهاد 100 گلدن کیلئے={{n}}Exp'
  },
  '幸运礼物100金币={{n}}Exp': {
    zh_CN: '幸运礼物100金币={{n}}Exp',
    en_US: 'Lucky Gift 100 Coins={{n}}Exp',
    ar_SA: 'جوائز مثلثة 100 طلبة نقدية={{n}}Exp',
    tr_TR: 'Çok Zararlı Hediye 100 Gümüş Mübarek={{n}}Exp',
    pt_BR: 'Presente Sorte 100 Moedas de Ouro={{n}}Exp',
    id_ID: 'Hadiah Lucky 100 Koin Emas={{n}}Exp',
    ru_RU: 'Выигрышный подарок 100 золотых монет={{n}}Exp',
    uz_UZ: "Mavjud yetkazib 100 so'mlik kupon={{n}}Exp",
    fa_IR: 'پیشنهاد موفق 100 گلدان={{n}}Exp',
    ur_PK: 'موفق پیشنهاد 100 گلدن کیلئے={{n}}Exp'
  },
  公会大厅: {
    zh_CN: '公会大厅',
    en_US: 'Agency Hall',
    ar_SA: 'المنزل الأساسي',
    tr_TR: 'Kuruluş Salonu',    
    pt_BR: 'Salão da Casa de Guerra',
    id_ID: 'Ruang Keluarga',
    ru_RU: 'Гостиница Клуба',
    uz_UZ: 'Kurilish xonasi',
    fa_IR: 'باغ کارگری',
    ur_PK: 'کارگری کیلئے'
  },
  公会主页: {
    zh_CN: '公会主页',
    en_US: 'Agency Homepage',
    ar_SA: 'الصفحة الرئيسية للوكالة',
    tr_TR: 'Ajans Ana Sayfası',
    pt_BR: 'Página Inicial da Agência',
    id_ID: 'Beranda Agensi',
    ru_RU: 'Главная страница агентства',
    uz_UZ: 'Agentlik Bosh Sahifasi',
    fa_IR: 'صفحه اصلی آژانس',
    ur_PK: 'ایجنسی ہوم',
  },
  创建: {
    zh_CN: '创建',
    en_US: 'Create',
    ar_SA: 'إنشاء',
    tr_TR: 'Oluştur',
    pt_BR: 'Criar',
    id_ID: 'Membuat',
    ru_RU: 'Создать',
    uz_UZ: 'Yaratish',
    fa_IR: 'ساخت',
    ur_PK: 'ساخت'
  },
  输入公会ID: {
    zh_CN: '输入公会ID',
    en_US: 'Enter Agency ID',
    ar_SA: 'أدخل رقم الأساسي',
    tr_TR: 'Kuruluş ID\'sini Girin',
    pt_BR: 'Digite o ID da Casa de Guerra',
    id_ID: 'Masukkan ID Keluarga',
    ru_RU: 'Введите ID Клуба',
    uz_UZ: 'Kurilish ID ni kiriting',
    fa_IR: 'ایدی کارگری را وارد کنید',
    ur_PK: 'کارگری کیلئے کا دھرنے کریں'
  },
  公会ID: {
    zh_CN: '公会ID',
    en_US: 'Agency ID',
    ar_SA: 'رقم الأساسي',
    tr_TR: 'Kuruluş ID\'si',
    pt_BR: 'ID da Casa de Guerra',
    id_ID: 'ID Keluarga',
    ru_RU: 'ID Клуба',
    uz_UZ: 'Kurilish ID',
    fa_IR: 'ایدی کارگری',
    ur_PK: 'کارگری کیلئے کا دھرنے'
  },
  创建公会: {
    zh_CN: '创建公会',
    en_US: 'Create Agency',
    ar_SA: 'إنشاء الأساسي',
    tr_TR: 'Kuruluş Oluştur',
    pt_BR: 'Criar Casa de Guerra',
    id_ID: 'Membuat Keluarga',
    ru_RU: 'Создать Клуб',
    uz_UZ: 'Kurilish yaratish',
    fa_IR: 'ساخت کارگری',
    ur_PK: 'کارگری ساخت'
  },
  封面: {
    zh_CN: '封面',
    en_US: 'Cover',
    ar_SA: 'غطاء',
    tr_TR: 'Kapak',
    pt_BR: 'Capa',
    id_ID: 'Kap',
    ru_RU: 'Обложка',
    uz_UZ: 'Kap',
    fa_IR: 'کاپ',
    ur_PK: 'کاپ'
  },
  请选择小于3M的图片: {
    zh_CN: '请选择小于3M的图片',
    en_US: 'Please select a picture less than 3M',
    ar_SA: 'الرجاء اختيار صورة أقل من 3 ميجا',
    tr_TR: 'Lütfen 3MB\'tan az bir resim seçin',
    pt_BR: 'Por favor, selecione uma imagem com menos de 3MB',
    id_ID: 'Silakan pilih gambar kurang dari 3MB',
    ru_RU: 'Пожалуйста, выберите изображение меньше 3МБ',
    uz_UZ: 'Iltimos, rasm 3MB dan kam bo\'ylab kimga tasdiqlang',
    fa_IR: 'لطفا یک تصویر کمتر از 3 مگابایت را انتخاب کنید',
    ur_PK: 'لطفا یک تصویر کمتر از 3 مگابایت را انتخاب کریں'
  },
  上级外管或BD: {
    zh_CN: '上级外管或BD',
    en_US: 'Upper Admin or BD',
    ar_SA: 'الإدارة العليا أو التنفيذية',
    tr_TR: 'Üst Yönetim veya BD',
    pt_BR: 'Gestão Superior ou BD',
    id_ID: 'Manajemen Atas atau BD',
    ru_RU: 'Верховный управляющий или БД',
    uz_UZ: 'Maxsus huquqiy huquqda yoki BD',
    fa_IR: 'سرپرستی بالاتر یا BD',
    ur_PK: 'بالاترین مدیریت یا BD'
  },
  输入ID: {
    zh_CN: '输入ID',
    en_US: 'Enter ID',
    ar_SA: 'أدخل معرف',
    tr_TR: 'ID Girin',
    pt_BR: 'Digite o ID',
    id_ID: 'Masukkan ID',
    ru_RU: 'Введите ID',
    uz_UZ: 'IDni kiriting',
    fa_IR: 'شناسه را وارد کنید',
    ur_PK: 'ID درج کریں',
  },
  所属国家或地区: {
    zh_CN: '所属国家或地区',
    en_US: 'Country or region of origin',
    ar_SA: 'بلد أو منطقة المنشأ',
    tr_TR: 'Ülke veya Bölge',
    pt_BR: 'País ou Região',
    id_ID: 'Negara atau Wilayah',
    ru_RU: 'Страна или регион',
    uz_UZ: 'Mamlakat yoki tuman',
    fa_IR: 'کشور یا منطقه',
    ur_PK: 'پالتو یا منطقہ'
  },
  'Tips: 如对上级外管或 BD 不了解，可联系官方 WhatsApp:{{n}}': {
    zh_CN: 'Tips: 如对上级外管或 BD 不了解，可联系官方 WhatsApp:{{n}}',
    en_US: 'Tips: If you are not familiar with the upper admin or BD, please contact the official WhatsApp:{{n}}',
    ar_SA: 'نصائح: إذا لم تعلم الإدارة العليا أو التنفيذية، يرجى الاتصال بالمركز الرسمي الفني الخاص بالواتساب:{{n}}',
    tr_TR: 'İpucu: Üst yönetim veya BD hakkında bilgi almak istemiyorsanız, lütfen resmi WhatsApp\'ta iletişime geçin:{{n}}',
    pt_BR: 'Dicas: Se você não estiver familiarizado com a gestão superior ou BD, por favor, contate o WhatsApp oficial:{{n}}',
    id_ID: 'Tips: Jika Anda tidak familiar dengan manajemen atas atau BD, silakan hubungi WhatsApp resmi:{{n}}',
    ru_RU: 'Подсказка: Если вы не знаете верховного управляющего или БД, свяжитесь с официальным WhatsApp:{{n}}',
    uz_UZ: 'Qo\'shimcha ma\'lumot: Agar sizning maxsus huquqiy huquqda yoki BD haqida ma\'lumot bermang o\'zroq bo\'lmasligi sizga ofisdagi WhatsApp orqali bog\'laning:{{n}}',
    fa_IR: 'نکات: زمانی که با سرپرستی بالاتر یا BD آشنایی ندارید، لطفا از این راه به رسانه فنی مرکزی اینترنتی خود ارتباط بگیرید:{{n}}',
    ur_PK: 'نکات: زمانی کے سرپرستی بالاتر یا BD کیا ہے، اپنا فنی مرکزی واتساب کی رسائی رکھنے کے لئے تماس بگیرید:{{n}}'
  },
  请输入外管或BD的ID: {
    zh_CN: '请输入外管或BD的ID',
    en_US: 'Please enter the ID of the Admin or BD',
    ar_SA: 'الرجاء إدخال رقم الإدارة العليا أو التنفيذية',
    tr_TR: 'Üst yönetim veya BD ID\'sini girin',
    pt_BR: 'Por favor, insira o ID da gestão superior ou BD',
    id_ID: 'Silakan masukkan ID manajemen atas atau BD',
    ru_RU: 'Пожалуйста, введите ID верховного управляющего или БД',
    uz_UZ: 'Iltimos, maxsus huquqiy huquqda yoki BD ID ni kiriting',
    fa_IR: 'لطفا ایدی سرپرستی بالاتر یا BD را وارد کنید',
    ur_PK: 'لطفا کارگری کیلئے یا BD کا دھرنے کریں'
  },
  选择地区: {
    zh_CN: '选择地区',
    en_US: 'Select Region',
    ar_SA: 'اختر منطقة',
    tr_TR: 'Bölge Seç',
    pt_BR: 'Selecione a Região',
    id_ID: 'Pilih Wilayah',
    ru_RU: 'Выберите регион',
    uz_UZ: 'Tilni tanlang',
    fa_IR: 'انتخاب منطقه',
    ur_PK: 'منطقہ منتخب کریں'
  },
  取消: {
    zh_CN: '取消',
    en_US: 'Cancel',
    ar_SA: 'يلغي',
    tr_TR: 'İptal',
    pt_BR: 'Cancelar',
    id_ID: 'Batal',
    ru_RU: 'Отмена',
    uz_UZ: 'Bekor qilish',
    fa_IR: 'لغو',
    ur_PK: 'کنسل کریں'
  },
  确定: {
    zh_CN: '确定',
    en_US: 'Confirm',
    ar_SA: 'تأكيد',
    tr_TR: 'Onayla',
    pt_BR: 'Confirmar',
    id_ID: 'Konfirmasi',
    ru_RU: 'Подтвердить',
    uz_UZ: 'Tasdiqlash',
    fa_IR: 'تایید',
    ur_PK: 'تصدیق کریں'
  },
  请输入公会名称: {
    zh_CN: '请输入公会名称',
    en_US: 'Please enter the name of the Agency',
    ar_SA: 'الرجاء إدخال اسم الأساسي',
    tr_TR: 'Kuruluşun adını girin',
    pt_BR: 'Por favor, insira o nome da Casa de Guerra',
    id_ID: 'Silakan masukkan nama Keluarga',
    ru_RU: 'Пожалуйста, введите название Клуба',
    uz_UZ: 'Iltimos, kurilish nomini kiriting',
    fa_IR: 'لطفا نام کارگری را وارد کنید',
    ur_PK: 'لطفا کارگری کا نام را وارد کریں'
  },
  请上传公会封面: {
    zh_CN: '请上传公会封面',
    en_US: 'Please upload the Agency cover',
    ar_SA: 'الرجاء رفع غطاء الأساسي',
    tr_TR: 'Kuruluş kapak fotoğrafını yükleyin',
    pt_BR: 'Por favor, envie a capa da Casa de Guerra',
    id_ID: 'Silakan unggah kartu Keluarga',
    ru_RU: 'Пожалуйста, загрузите обложку Клуба',
    uz_UZ: 'Iltimos, kurilish kapağı yuklang',
    fa_IR: 'لطفا کاپ را آپلود کنید',
    ur_PK: 'لطفا کارگری کا کاپ را آپلود کریں'
  },
  请选择外管或BD: {
    zh_CN: '请选择外管或BD',
    en_US: 'Please select the Admin or BD',
    ar_SA: 'الرجاء اختيار الإدارة العليا أو التنفيذية',
    tr_TR: 'Üst yönetim veya BD\'yi seçin',
    pt_BR: 'Por favor, selecione a gestão superior ou BD',
    id_ID: 'Silakan pilih manajemen atas atau BD',
    ru_RU: 'Пожалуйста, выберите верховного управляющего или БД',
    uz_UZ: 'Iltimos, maxsus huquqiy huquqda yoki BDni tanlang',
    fa_IR: 'لطفا سرپرستی بالاتر یا BD را انتخاب کنید',
    ur_PK: 'لطفا بالاترین مدیریت یا BD را منتخب کریں'
  },
  标签: {
    zh_CN: '标签',
    en_US: 'Label',
    ar_SA: 'تسمية',
    tr_TR: 'Etiket',
    pt_BR: 'Rótulo',
    id_ID: 'Label',
    ru_RU: 'Тег',
    uz_UZ: 'Etiket',
    fa_IR: 'برچسب',
    ur_PK: 'تسمیم'
  },
  勋章: {
    zh_CN: '勋章',
    en_US: 'Medal',
    ar_SA: 'جوزيف',
    tr_TR: 'Medal',
    pt_BR: 'Medalha',
    id_ID: 'Medali',
    ru_RU: 'Медаль',
    uz_UZ: 'Jamoat',
    fa_IR: 'مدال',
    ur_PK: 'مدال'
  },
  已申请: {
    zh_CN: '已申请',
    en_US: 'Applied',
    ar_SA: 'تم التقدم',
    tr_TR: 'Başvuruldu',
    pt_BR: 'Aplicado',
    id_ID: 'Diterima',
    ru_RU: 'Заявка принята',
    uz_UZ: 'Taqdim qilingan',
    fa_IR: 'تقدیم شده',
    ur_PK: 'تقدیم شدہ'
  },
  我的公会:  {
    zh_CN: '我的公会',
    en_US: 'My Agency',
    ar_SA: 'الأساسي الخاص بي',
    tr_TR: 'Benim Kuruluşum',
    pt_BR: 'Minha Casa de Guerra',
    id_ID: 'Keluarga Saya',
    ru_RU: 'Моя Клуба',
    uz_UZ: 'Mening kurilishim',
    fa_IR: 'کارگری من',
    ur_PK: 'من کارگری'
  },
  确认申请加入该公会: {
    zh_CN: '确认申请加入该公会?',
    en_US: 'Confirm applying to join this Agency?',
    ar_SA: 'تأكيد التقدم للانضمام إلى هذه الأساسية؟',
    tr_TR: 'Bu Kuruluşa katılmak için başvuruyu onaylayın mı?',
    pt_BR: 'Confirma se inscrever neste Agência?',
    id_ID: 'Konfirmasi mendaftar untuk bergabung dengan Keluarga ini?',
    ru_RU: 'Подтвердите заявку на присоединение к этому Клубу?',
    uz_UZ: 'Taqdim qilishni bu kurilishga ajoyib ketishni tasdiqlang?',
    fa_IR: 'تایید این کارگری را به عنوان یک کارگری جدید اعلام کنید؟',
    ur_PK: 'کارگری کے لئے ان کی آپ کی آپ کی تقدیم کیا گیا ہے؟'
  },
  无法重新申请加入公会: {
    zh_CN: '无法重新申请加入公会',
    en_US: 'Unable to reapply to join this Agency',
    ar_SA: 'لا يمكن إعادة التقدم للانضمام إلى هذه الأساسية',
    tr_TR: 'Bu Kuruluşa katılmak için başvuruyu tekrar yapamazsın',
    pt_BR: 'Incapaz de se inscrever neste Agência novamente',
    id_ID: 'Tidak dapat mengulangi pendaftaran untuk bergabung dengan Keluarga ini',
    ru_RU: 'Невозможно повторно подать заявку на присоединение к этому Клубу',
    uz_UZ: 'Bu kurilishga ajoyib ketishni qayta tasdiqlash mumkin emas',
    fa_IR: 'این کارگری را به عنوان یک کارگری جدید اعلام نمی‌کنم',
    ur_PK: 'کارگری کے لئے ان کی آپ کی آپ کی تقدیم کیا گیا ہے'
  },
  提交成功: {
    zh_CN: '提交成功',
    en_US: 'Submitted successfully',
    ar_SA: 'تم التقدم بنجاح',
    tr_TR: 'Başvuru başarıyla gönderildi',
    pt_BR: 'Submetido com sucesso',
    id_ID: 'Berhasil mengajukan',
    ru_RU: 'Заявка успешно подана',
    uz_UZ: 'Taqdim qilindi',
    fa_IR: 'تقدیم شد',
    ur_PK: 'تقدیم کر دیا گیا'
  },
  '等级越高，获得等级勋章越豪华': {
    zh_CN: '等级越高，获得等级勋章越豪华',
    en_US: 'The higher the level, the more luxurious the level medal',
    ar_SA: 'على حد الأسعار، يكفي أكبر جوزيف للمستوى',
    tr_TR: 'Daha yüksek seviye, seviye medali daha pahalı olur',
    pt_BR: 'Quanto mai alto o nível, mais cara é a medalha do nível',
    id_ID: 'Semakin tinggi level, semakin mahal yang didapatkan',
    ru_RU: 'Чем выше уровень, тем дороже уровневая медаль',
    uz_UZ: 'Seviyaga tegishli bo\'lgan jamoat narsa qiymati kamaytiriladi',
    fa_IR: 'بالاترین مدال هم بیشتر قیمت دارد',
    ur_PK: 'بالاترین مدال میں قیمت بالاتر ہوں'
  },
  常用功能: {
    zh_CN: '常用功能',
    en_US: 'Common Functions',
    ar_SA: 'الوظائف الشائعة',
    tr_TR: 'Genel İşlevler',
    pt_BR: 'Funções Comuns',
    id_ID: 'Fungsi Umum',
    ru_RU: 'Общие функции',
    uz_UZ: 'Umumiy funksiyalar',
    fa_IR: 'وظایف پرکاربرد',
    ur_PK: 'میں کاربردی معاملات'
  },
  数据中心: {
    zh_CN: '数据中心',
    en_US: 'Data Center',
    ar_SA: 'مركز البيانات', 
    tr_TR: 'Veri Merkezi',
    pt_BR: 'Centro de Dados',
    id_ID: 'Pusat Data',
    ru_RU: 'Центральный центр',
    uz_UZ: 'Ma\'ruza',
    fa_IR: 'مرکز داده',
    ur_PK: 'دیتا مرکز'
  },
  成员: {
    zh_CN: '成员',
    en_US: 'Members',
    ar_SA: 'أعضاء',
    tr_TR: 'Üyeler',
    pt_BR: 'Membros',
    id_ID: 'Anggota',
    ru_RU: 'Участники',
    uz_UZ: 'Amal',
    fa_IR: 'اعضاء',
    ur_PK: 'عضویت'
  },
  编辑资料: {
    zh_CN: '编辑资料',
    en_US: 'Edit Profile',
    ar_SA: 'تحرير الملف الشخصي',
    tr_TR: 'Profili Düzenle',
    pt_BR: 'Editar Perfil',
    id_ID: 'Edit Profil',
    ru_RU: 'Редактировать профиль',
    uz_UZ: 'Profilni tahrirlash',
    fa_IR: 'پروفایل ویرایش',
    ur_PK: 'پروفایل ویرایش کریں'
  },
  公会名称: {
    zh_CN: '公会名称',
    en_US: 'Agency Name',
    ar_SA: 'اسم الأساسية',
    tr_TR: 'Kuruluş Adı',
    pt_BR: 'Nome da Casa de Guerra',
    id_ID: 'Nama Keluarga',
    ru_RU: 'Название Клуба',
    uz_UZ: 'Kurilish nomi',
    fa_IR: 'نام کارگری',
    ur_PK: 'نام کارگری'
  },
  公会宣言: {
    zh_CN: '公会宣言',
    en_US: 'Announcement',
    ar_SA: 'إعلان',
    tr_TR: 'Duyuru',
    pt_BR: 'Anúncio',
    id_ID: 'Pengumuman',
    ru_RU: 'Объявление',
    uz_UZ: 'E\'lon',
    fa_IR: 'آگاهی',
    ur_PK: 'آگاہ'
  },
  更新成功: {
    zh_CN: '更新成功',
    en_US: 'Updated successfully',
    ar_SA: 'تم تحديثه بنجاح',
    tr_TR: 'Güncelleme başarılı',
    pt_BR: 'Atualizado com sucesso',
    id_ID: 'Berhasil diperbarui',
    ru_RU: 'Обновление прошло успешно',
    uz_UZ: 'Yangilash muvaffaqiyatli',
    fa_IR: 'به روز رسانی شد',
    ur_PK: 'به روز رسانی کر دیا گیا'
  },
  成员管理: {
    zh_CN: '成员管理',
    en_US: 'Member Management',
    ar_SA: 'إدارة الأعضاء',
    tr_TR: 'Üye Yönetimi',
    pt_BR: 'Gestão de Membros',
    id_ID: 'Manajemen Anggota',
    ru_RU: 'Управление участниками',
    uz_UZ: 'Amalni boshqarish',
    fa_IR: 'مدیریت اعضاء',
    ur_PK: 'عضویت کی مدیریت'
  },
  加入公会申请: {
    zh_CN: '加入公会申请',
    en_US: 'Apply to Join Agency',
    ar_SA: 'التقدم بطلب للانضمام إلى الوكالة',
    tr_TR: 'Ajansa Katılmak İçin Başvurun',
    pt_BR: 'Solicitar Adesão à Agência',
    id_ID: 'Mendaftar Bergabung dengan Keluarga',
    ru_RU: 'Заявка на присоединение к Клубу',
    uz_UZ: 'Kurilishga ajoyib ketishni tasdiqlash',
    fa_IR: 'کارگری را به عنوان یک کارگری جدید اعلام کنید',
    ur_PK: 'کارگری کے لئے ان کی آپ کی آپ کی تقدیم کیا گیا ہے'
  },
  成员列表: {
    zh_CN: '成员列表',
    en_US: 'Member List',
    ar_SA: 'قائمة الأعضاء',
    tr_TR: 'Üye Listesi',
    pt_BR: 'Lista de Membros',
    id_ID: 'Daftar Anggota',
    ru_RU: 'Список участников',
    uz_UZ: 'Amal ro\'yxati',
    fa_IR: 'لیست اعضاء',
    ur_PK: 'لیست عضویت',
  },
  加入申请: {
    zh_CN: '加入申请',
    en_US: 'Apply to Join',
    ar_SA: 'التقدم بطلب الانضمام',
    tr_TR: 'Katılmak İçin Başvurun',
    pt_BR: 'Solicitar Adesão',
    id_ID: 'Mendaftar Bergabung',
    ru_RU: 'Заявка на присоединение',
    uz_UZ: 'Kurilishga ajoyib ketish',
    fa_IR: 'درخواست عضویت',
    ur_PK: 'تقدیم کرنے کے لئے'
  },
  申请时间: {
    zh_CN: '申请时间',
    en_US: 'Apply Time',
    ar_SA: 'وقت التقدم',
    tr_TR: 'Başvuru Zamanı',
    pt_BR: 'Tempo de Solicitação',
    id_ID: 'Waktu Pendaftaran',
    ru_RU: 'Время заявки',
    uz_UZ: 'Taqdim vaqti',
    fa_IR: 'زمان درخواست',
    ur_PK: 'تقدیم زمان'
  },
  '感谢举报,我们将在24小时内处理': {
    zh_CN: '感谢举报,我们将在24小时内处理',
    en_US: 'Thank you for reporting, we will handle it within 24 hours',
    ar_SA: 'شكرا للإبلاغ، سوف نقوم بالتحديد في 24 ساعة',
    tr_TR: 'Rapor vermek için teşekkür ederiz, 24 saat içerisinde işleme alacağız',
    pt_BR: 'Obrigado pela denúncia, entraremos em contato em até 24 horas',
    id_ID: 'Terima kasih atas laporan, kami akan segera menangani dalam 24 jam',
    ru_RU: 'Спасибо за жалобу, мы обработаем в течение 24 часов',
    uz_UZ: 'Rapor qoldirish uchun rahmat, 24 soatda amalga oshirishga harakat qilamiz',
    fa_IR: 'شكری از گزارش شما، در 24 ساعت انجام خواهیم داد',
    ur_PK: 'گزارش کی تشکر، ۲۴ ساعت میں مدیریت کیا گیا ہے'
  },
  暂无数据: {
    zh_CN: '暂无数据',
    en_US: 'No Data',
    ar_SA: 'لا توجد بيانات',
    tr_TR: 'Veri Yok',
    pt_BR: 'Sem Dados',
    id_ID: 'Tidak Ada Data',
    ru_RU: 'Нет данных',
    uz_UZ: 'Ma\'lumot yo\'q',
    fa_IR: 'بدون داده',
    ur_PK: 'کوئی ڈیٹا نہیں'
  },
  确认同意该用户加入公会: {
    zh_CN: '确认同意该用户加入公会?',
    en_US: 'Confirm that you agree with the user to join the agency?',
    ar_SA: 'هل يوجد موافقة من المستخدم للانضمام إلى الوكالة؟',
    tr_TR: 'Kullanıcıyı kuruluşa katılmak için kabul etmeyi onaylıyor musunuz?',
    pt_BR: 'O usuário concorda em se juntar à agência?',
    id_ID: 'Apakah pengguna menyetujui bergabung dengan keluarga?',
    ru_RU: 'Подтвердите, что пользователь согласен с участием в Клубе?',
    uz_UZ: 'Foydalanuvchi ro\'yxatdan o\'tganini kurilishga ruxsat berishni tasdiqlang?',
    fa_IR: 'کاربر انتقادات خود را دارد؟',
    ur_PK: 'کاربر انتقادات کے لئے کیا گیا ہے؟'
  },
  确认拒绝该用户加入公会: {
    zh_CN: '确认拒绝该用户加入公会?',
    en_US: 'Confirm that you reject the user from joining the agency?',
    ar_SA: 'هل يوجد موافقة من المستخدم للانضمام إلى الوكالة؟',
    tr_TR: 'Kullanıcıyı kuruluşa katılmak için kabul etmeyi reddetmeyi onaylıyor musunuz?',
    pt_BR: 'O usuário concorda em não se juntar à agência?',
    id_ID: 'Apakah pengguna tidak setuju bergabung dengan keluarga?',
    ru_RU: 'Подтвердите, что пользователь не согласен с участием в Клубе?',
    uz_UZ: 'Foydalanuvchi ro\'yxatdan o\'tganini kurilishga ruxsat berishni qaytarishni tasdiqlang?',
    fa_IR: 'کاربر انتقادات خود را دارد؟',
    ur_PK: 'کاربر انتقادات کے لئے کیا گیا ہے؟'
  },
  加入时间: {
    zh_CN: '加入时间',
    en_US: 'Join Time',
    ar_SA: 'وقت الانضمام',
    tr_TR: 'Katılma Zamanı',
    pt_BR: 'Tempo de Entrada',
    id_ID: 'Waktu Bergabung',
    ru_RU: 'Время вступления',
    uz_UZ: 'Kurish vaqti',
    fa_IR: 'زمان ورود',
    ur_PK: 'تلاش کی زمان'
  },
  更多操作: {
    zh_CN: '更多操作',
    en_US: 'More Operations',
    ar_SA: 'العمليات الأكثر',
    tr_TR: 'Daha Fazla İşlem',
    pt_BR: 'Mais Operações',
    id_ID: 'Operasi Lainnya',
    ru_RU: 'Дополнительные операции',
    uz_UZ: 'Boshqa amal',
    fa_IR: 'ادامه ترمین',
    ur_PK: 'اقدامات بیشتر'
  },
  设为管理员: {
    zh_CN: '设为管理员',
    en_US: 'Set as Admin',  
    ar_SA: 'تعيين كمشرف',
    tr_TR: 'Yönetici Olarak Ayarla',
    pt_BR: 'Definir como Administrador',
    id_ID: 'Atur sebagai Admin',
    ru_RU: 'Назначить администратором',
    uz_UZ: 'Admin ga tayyorlash',
    fa_IR: 'تعیین به عنوان مدیر',
    ur_PK: 'مدیر کی تعیین کریں'
  },
  取消管理员: {
    zh_CN: '取消管理员',
    en_US: 'Remove Admin',
    ar_SA: 'إزالة من الوكالة',
    tr_TR: 'Yöneticiyi Kaldır',
    pt_BR: 'Remover Administrador',
    id_ID: 'Hapus Admin',
    ru_RU: 'Убрать из администраторов',
    uz_UZ: 'Admin o\'chirish',
    fa_IR: 'حذف مدیر',
    ur_PK: 'مدیر حذف کریں'
  },
  移出公会: {
    zh_CN: '移出公会',
    en_US: 'Remove from Agency',
    ar_SA: 'إزالة من الوكالة',
    tr_TR: 'Kuruluştan Çıkar',
    pt_BR: 'Remover da Agência',
    id_ID: 'Keluarga Diluar',
    ru_RU: 'Удалить из Клуба',
    uz_UZ: 'Kurilgandan olib tashlash',
    fa_IR: 'از کارگری حذف کردن',
    ur_PK: 'کارگری میں حذف کریں'
  },
  确认将该用户移出公会: {
    zh_CN: '确认将该用户移出公会?',
    en_US: 'Confirm that the user will be removed from the agency?',
    ar_SA: 'هل تريد حذف المستخدم من الوكالة؟',
    tr_TR: 'Kullanıcıyı kuruluştan çıkaracaksınız mı?',
    pt_BR: 'O usuário será removido da agência?',
    id_ID: 'Apakah pengguna akan dihapus dari keluarga?',
    ru_RU: 'Подтвердите, что пользователь будет удален из Клуба?',
    uz_UZ: 'Foydalanuvchini kurilgandan olib tashlashni tasdiqlang?',
    fa_IR: 'کاربر حذف شود؟',
    ur_PK: 'کاربر کی حذف کرنے کے لئے کیا گیا ہے؟'
  },
  确认解除该用户的公会管理员: {
    zh_CN: '确认解除该用户的公会管理员?',
    en_US: 'Confirm that the user will be removed as an agency admin?',
    ar_SA: 'هل تريد إزالة المستخدم من قائمة الوكالة؟',
    tr_TR: 'Kullanıcının yönetici yetkisini kaldırmak istiyor musunuz?',
    pt_BR: 'O usuário será removido da lista de administradores da agência?',
    id_ID: 'Apakah pengguna akan dihapus dari daftar admin keluarga?',
    ru_RU: 'Подтвердите, что пользователь будет удален из списка администраторов Клуба?',
    uz_UZ: 'Foydalanuvchining kurilish admini o\'chirishni tasdiqlang?',
    fa_IR: 'کاربر حذف شود؟',
    ur_PK: 'کاربر کی حذف کرنے کے لئے کیا گیا ہے؟'
  },
  确认设置该用户为公会管理员: {
    zh_CN: '确认设置该用户为公会管理员?',
    en_US: 'Confirm that the user will be set as an agency admin?',
    ar_SA: 'هل تريد تعيين المستخدم كمشرف في الوكالة؟',
    tr_TR: 'Kullanıcıyı kuruluş yöneticisi olarak ayarlamak istiyor musunuz?',
    pt_BR: 'O usuário será definido como administrador da agência?',
    id_ID: 'Apakah pengguna akan dijadikan admin keluarga?',
    ru_RU: 'Подтвердите, что пользователь будет назначен администратором Клуба?',
    uz_UZ: 'Foydalanuvchini kurilish admini tayyorlashni tasdiqlang?',
    fa_IR: 'کاربر به عنوان مدیر کارگری شود؟',
    ur_PK: 'کاربر کی تعیین کرنے کے لئے کیا گیا ہے؟'
  },
  加载中: {
    zh_CN: '加载中…',
    en_US: 'Loading...',
    ar_SA: 'جاري التحميل...',
    tr_TR: 'Yükleniyor...',
    pt_BR: 'Carregando...',
    id_ID: 'Memuat...',
    ru_RU: 'Загрузка...',
    uz_UZ: 'Yuklanmoqda...',  
    fa_IR: 'در حال بارگذاری...',
    ur_PK: 'لودنے کا درخواست ہوئے...'
  },
  外管: {
    zh_CN: '外管',
    en_US: 'Admin',
    ar_SA: 'المشرف',
    tr_TR: 'Denetçi',
    pt_BR: 'Supervisor',
    id_ID: 'Pengawas',
    ru_RU: 'Супервайзер',
    uz_UZ: 'Nazoratchi',
    fa_IR: 'سرپرست',
    ur_PK: 'نگران',
  },
  操作: {
    zh_CN: '操作',
    en_US: 'Operation',
    ar_SA: 'عملية',
    tr_TR: 'İşlem',
    pt_BR: 'Operação',
    id_ID: 'Operasi',
    ru_RU: 'Операция',
    uz_UZ: 'Amal',
    fa_IR: 'عملیات',
    ur_PK: 'عمل',
  },
  发放礼包: {
    zh_CN: '发放礼包',
    en_US: 'Issue Gift Pack',
    ar_SA: 'إصدار الحزمة',
    tr_TR: 'Hediye Paketini Dağıt',
    pt_BR: 'Emitir Pacote de Presente',
    id_ID: 'Terbitkan Paket Hadiah',
    ru_RU: 'Выдать подарочный набор',
    uz_UZ: 'Sovg‘a to‘plamini berish',
    fa_IR: 'صدور بسته هدیه',
    ur_PK: 'تحفہ پیک جاری کریں',
  },
  公会申请: {
    zh_CN: '公会申请',
    en_US: 'Agency Application',
    ar_SA: 'طلب الوكالة',
    tr_TR: 'Ajans Başvurusu',
    pt_BR: 'Solicitação de Agência',
    id_ID: 'Pengajuan Agensi',
    ru_RU: 'Заявка агентства',
    uz_UZ: 'Agentlik arizasi',
    fa_IR: 'درخواست آژانس',
    ur_PK: 'ایجنسی کی درخواست',
  },
  数据查看: {
    zh_CN: '数据查看',
    en_US: 'Data View',
    ar_SA: 'عرض البيانات',
    tr_TR: 'Veri Görüntüleme',
    pt_BR: 'Visualizar Dados',
    id_ID: 'Lihat Data',
    ru_RU: 'Просмотр данных',
    uz_UZ: 'Maʼlumotlarni ko‘rish',
    fa_IR: 'مشاهده داده‌ها',
    ur_PK: 'ڈیٹا دیکھیں',
  },
  下级BD列表: {
    zh_CN: '下级BD列表',
    en_US: 'Sub BD List',
    ar_SA: 'قائمة BD الفرعية',
    tr_TR: 'Alt BD Listesi',
    pt_BR: 'Lista de BD Subordinados',
    id_ID: 'Daftar BD Bawahan',
    ru_RU: 'Список подчинённых BD',
    uz_UZ: 'Quyi BD ro‘yxati',
    fa_IR: 'فهرست BDهای زیرمجموعه',
    ur_PK: 'زیریں BD فہرست',
  },
  公会数据: {
    zh_CN: '公会数据',
    en_US: 'Agency Data',
    ar_SA: 'بيانات الوكالة',
    tr_TR: 'Ajans Verileri',
    pt_BR: 'Dados da Agência',
    id_ID: 'Data Agensi',
    ru_RU: 'Данные агентства',
    uz_UZ: 'Agentlik maʼlumotlari',
    fa_IR: 'داده‌های آژانس',
    ur_PK: 'ایجنسی ڈیٹا',
  },
  公会列表: {
    zh_CN: '公会列表',
    en_US: 'Agency List',
    ar_SA: 'قائمة الوكالات',
    tr_TR: 'Ajans Listesi',
    pt_BR: 'Lista de Agências',
    id_ID: 'Daftar Agensi',
    ru_RU: 'Список агентств',
    uz_UZ: 'Agentliklar ro‘yxati',
    fa_IR: 'فهرست آژانس‌ها',
    ur_PK: 'ایجنسیوں کی فہرست',
  },
  输入用户ID: {
    zh_CN: '输入用户ID',
    en_US: 'Enter User ID',
    ar_SA: 'أدخل معرف المستخدم',
    tr_TR: "Kullanıcı ID'si Girin",
    pt_BR: 'Digite o ID do Usuário',
    id_ID: 'Masukkan ID Pengguna',
    ru_RU: 'Введите ID пользователя',
    uz_UZ: 'Foydalanuvchi ID sini kiriting',
    fa_IR: 'شناسه کاربر را وارد کنید',
    ur_PK: 'صارف ID درج کریں',
  },
  发放记录: {
    zh_CN: '发放记录',
    en_US: 'Issue Records',
    ar_SA: 'سجلات الإصدار',
    tr_TR: 'Dağıtım Kayıtları',
    pt_BR: 'Registros de Emissão',
    id_ID: 'Riwayat Penerbitan',
    ru_RU: 'Записи выдачи',
    uz_UZ: 'Berish yozuvlari',
    fa_IR: 'سوابق صدور',
    ur_PK: 'اجراءات کے ریکارڈ',
  },
  礼包内容: {
    zh_CN: '礼包内容',
    en_US: 'Gift Pack Content',
    ar_SA: 'محتوى الحزمة',
    tr_TR: 'Hediye Paketi İçeriği',
    pt_BR: 'Conteúdo do Pacote',
    id_ID: 'Isi Paket Hadiah',
    ru_RU: 'Содержимое набора',
    uz_UZ: 'To‘plam tarkibi',
    fa_IR: 'محتوای بسته هدیه',
    ur_PK: 'تحفہ پیک کا مواد',
  },
  礼包列表: {
    zh_CN: '礼包列表',
    en_US: 'Gift Pack List',
    ar_SA: 'قائمة الحزم',
    tr_TR: 'Hediye Paket Listesi',
    pt_BR: 'Lista de Pacotes',
    id_ID: 'Daftar Paket Hadiah',
    ru_RU: 'Список наборов',
    uz_UZ: 'To‘plamlar ro‘yxati',
    fa_IR: 'فهرست بسته‌های هدیه',
    ur_PK: 'تحفہ پیک لسٹ',
  },
  礼包ID: {
    zh_CN: '礼包ID',
    en_US: 'Gift Pack ID',
    ar_SA: 'معرف الحزمة',
    tr_TR: "Hediye Paketi ID'si",
    pt_BR: 'ID do Pacote',
    id_ID: 'ID Paket Hadiah',
    ru_RU: 'ID набора',
    uz_UZ: 'To‘plam ID',
    fa_IR: 'شناسه بسته',
    ur_PK: 'پیک ID',
  },
  用户ID: {
    zh_CN: '用户ID',
    en_US: 'User ID',
    ar_SA: 'معرف المستخدم',
    tr_TR: "Kullanıcı ID'si",
    pt_BR: 'ID do Usuário',
    id_ID: 'ID Pengguna',
    ru_RU: 'ID пользователя',
    uz_UZ: 'Foydalanuvchi ID',
    fa_IR: 'شناسه کاربر',
    ur_PK: 'صارف ID',
  },
  发放: {
    zh_CN: '发放',
    en_US: 'Issue',
    ar_SA: 'إصدار',
    tr_TR: 'Dağıt',
    pt_BR: 'Emitir',
    id_ID: 'Terbitkan',
    ru_RU: 'Выдать',
    uz_UZ: 'Berish',
    fa_IR: 'صدور',
    ur_PK: 'جاری کریں',
  },
  '确认要给该用户发放礼包吗?': {
    zh_CN: '确认要给该用户发放礼包吗?',
    en_US: 'Confirm to issue a gift pack to this user?',
    ar_SA: 'تأكيد إصدار حزمة لهذا المستخدم؟',
    tr_TR: 'Bu kullanıcıya hediye paketi dağıtılsın mı?',
    pt_BR: 'Confirmar emissão de pacote de presente para este usuário?',
    id_ID: 'Konfirmasi menerbitkan paket hadiah ke pengguna ini?',
    ru_RU: 'Подтвердить выдачу подарочного набора этому пользователю?',
    uz_UZ: 'Ushbu foydalanuvchiga sovg‘a to‘plami berilsinmi?',
    fa_IR: 'صدور بسته هدیه برای این کاربر تأیید شود؟',
    ur_PK: 'کیا اس صارف کو تحفہ پیک جاری کرنا ہے؟',
  },
  发放于: {
    zh_CN: '发放于',
    en_US: 'Issued at',
    ar_SA: 'صُدر في',
    tr_TR: 'Dağıtım zamanı',
    pt_BR: 'Emitido em',
    id_ID: 'Diterbitkan pada',
    ru_RU: 'Выдано в',
    uz_UZ: 'Berilgan vaqti',
    fa_IR: 'صادر شده در',
    ur_PK: 'جاری کیا گیا',
  },
  待处理: {
    zh_CN: '待处理',
    en_US: 'Pending',
    ar_SA: 'قيد الانتظار',
    tr_TR: 'Beklemede',
    pt_BR: 'Pendente',
    id_ID: 'Tertunda',
    ru_RU: 'В ожидании',
    uz_UZ: 'Kutilmoqda',
    fa_IR: 'در انتظار',
    ur_PK: 'زیر التواء',
  },
  已处理: {
    zh_CN: '已处理',
    en_US: 'Processed',
    ar_SA: 'تمت المعالجة',
    tr_TR: 'İşlendi',
    pt_BR: 'Processado',
    id_ID: 'Diproses',
    ru_RU: 'Обработано',
    uz_UZ: 'Qayta ishlangan',
    fa_IR: 'پردازش شده',
    ur_PK: 'پراسس ہو چکا',
  },
  创建公会申请: {
    zh_CN: '创建公会申请',
    en_US: 'Agency Creation Application',
    ar_SA: 'طلب إنشاء وكالة',
    tr_TR: 'Ajans Kurma Başvurusu',
    pt_BR: 'Solicitação de Criação de Agência',
    id_ID: 'Pengajuan Pembuatan Agensi',
    ru_RU: 'Заявка на создание агентства',
    uz_UZ: 'Agentlik yaratish arizasi',
    fa_IR: 'درخواست ایجاد آژانس',
    ur_PK: 'ایجنسی بنانے کی درخواست',
  },
  批准: {
    zh_CN: '批准',
    en_US: 'Approve',
    ar_SA: 'موافقة',
    tr_TR: 'Onayla',
    pt_BR: 'Aprovar',
    id_ID: 'Setujui',
    ru_RU: 'Одобрить',
    uz_UZ: 'Maʼqullash',
    fa_IR: 'تأیید',
    ur_PK: 'منظور کریں',
  },
  '国家/地区': {
    zh_CN: '国家/地区',
    en_US: 'Country/Region',
    ar_SA: 'البلد / المنطقة',
    tr_TR: 'Ülke/Bölge',
    pt_BR: 'País/Região',
    id_ID: 'Negara/Wilayah',
    ru_RU: 'Страна/Регион',
    uz_UZ: 'Mamlakat/Hudud',
    fa_IR: 'کشور/منطقه',
    ur_PK: 'ملک/علاقہ',
  },
  经理ID: {
    zh_CN: '经理ID',
    en_US: 'Manager ID',
    ar_SA: 'معرف المدير',
    tr_TR: "Yönetici ID'si",
    pt_BR: 'ID do Gerente',
    id_ID: 'ID Manajer',
    ru_RU: 'ID менеджера',
    uz_UZ: 'Menejer ID',
    fa_IR: 'شناسه مدیر',
    ur_PK: 'منیجر ID',
  },
  创建者ID: {
    zh_CN: '创建者ID',
    en_US: 'Creator ID',
    ar_SA: 'معرف المنشئ',
    tr_TR: "Oluşturan ID'si",
    pt_BR: 'ID do Criador',
    id_ID: 'ID Pembuat',
    ru_RU: 'ID создателя',
    uz_UZ: 'Yaratgan ID',
    fa_IR: 'شناسه ایجادکننده',
    ur_PK: 'خالق ID',
  },
  创建时间: {
    zh_CN: '创建时间',
    en_US: 'Creation Time',
    ar_SA: 'وقت الإنشاء',
    tr_TR: 'Oluşturma Zamanı',
    pt_BR: 'Hora de Criação',
    id_ID: 'Waktu Pembuatan',
    ru_RU: 'Время создания',
    uz_UZ: 'Yaratilgan vaqti',
    fa_IR: 'زمان ایجاد',
    ur_PK: 'بننے کا وقت',
  },
  已通过: {
    zh_CN: '已通过',
    en_US: 'Approved',
    ar_SA: 'تمت الموافقة',
    tr_TR: 'Onaylandı',
    pt_BR: 'Aprovado',
    id_ID: 'Disetujui',
    ru_RU: 'Одобрено',
    uz_UZ: 'Tasdiqlandi',
    fa_IR: 'تأیید شده',
    ur_PK: 'منظور شدہ',
  },
  处理时间: {
    zh_CN: '处理时间',
    en_US: 'Processing Time',
    ar_SA: 'وقت المعالجة',
    tr_TR: 'İşleme Süresi',
    pt_BR: 'Tempo de Processamento',
    id_ID: 'Waktu Pemrosesan',
    ru_RU: 'Время обработки',
    uz_UZ: 'Qayta ishlash vaqti',
    fa_IR: 'زمان پردازش',
    ur_PK: 'پراسس کا وقت',
  },
  '是否同意{{id}}申请{{n}}创建?': {
    zh_CN: '是否同意{{id}}申请{{n}}创建？',
    en_US: 'Agree with {{id}} applying to create {{n}}?',
    ar_SA: 'هل توافق على طلب {{id}} لإنشاء {{n}}؟',
    tr_TR:
      '{{id}} kullanıcısının {{n}} oluşturma isteğini kabul ediyorsunuz mu?',
    pt_BR: 'Concorda com {{id}} criando {{n}}?',
    id_ID: 'Setuju {{id}} membuat {{n}}?',
    ru_RU: 'Согласиться с заявкой {{id}} на создание {{n}}?',
    uz_UZ: '{{id}} tomonidan {{n}} yaratish so‘roviga rozi bo‘lasizmi?',
    fa_IR: 'با درخواست {{id}} برای ایجاد {{n}} موافقید؟',
    ur_PK: 'کیا آپ {{id}} کی {{n}} بنانے کی درخواست مانتے ہیں؟',
  },
  '是否拒绝{{id}}申请{{n}}创建?': {
    zh_CN: '是否拒绝{{id}}申请{{n}}创建？',
    en_US: 'Reject {{id}} applying to create {{n}}?',
    ar_SA: 'هل ترفض طلب {{id}} لإنشاء {{n}}؟',
    tr_TR:
      '{{id}} kullanıcısının {{n}} oluşturma isteğini reddediyorsunuz mu?',
    pt_BR: 'Rejeitar {{id}} criando {{n}}?',
    id_ID: 'Tolak {{id}} membuat {{n}}?',
    ru_RU: 'Отклонить заявку {{id}} на создание {{n}}?',
    uz_UZ: '{{id}} ning {{n}} yaratish so‘rovini rad etasizmi?',
    fa_IR: 'آیا درخواست {{id}} برای ایجاد {{n}} را رد می‌کنید؟',
    ur_PK: 'کیا آپ {{id}} کی {{n}} بنانے کی درخواست رد کریں گے؟',
  },
  '哎呀，没有搜索结果': {
    zh_CN: '哎呀，没有搜索结果',
    en_US: 'Oops, no search results',
    ar_SA: 'عفوًا، لا توجد نتائج بحث',
    tr_TR: 'Hay aksi, arama sonucu yok',
    pt_BR: 'Ops, nenhum resultado de pesquisa',
    id_ID: 'Ups, tidak ada hasil pencarian',
    ru_RU: 'Упс, результатов поиска нет',
    uz_UZ: 'Voy, qidiruv natijalari topilmadi',
    fa_IR: 'اوه، نتیجه جستجو پیدا نشد',
    ur_PK: 'اوہ، تلاش کے نتائج نہیں ملے',
  },
  总计: {
    zh_CN: '总计',
    en_US: 'Total',
    ar_SA: 'الإجمالي',
    tr_TR: 'Toplam',
    pt_BR: 'Total',
    id_ID: 'Total',
    ru_RU: 'Итого',
    uz_UZ: 'Jami',
    fa_IR: 'مجموع',
    ur_PK: 'کل',
  },
  BD数量: {
    zh_CN: 'BD数量',
    en_US: 'BD Amount',
    ar_SA: 'عدد BD',
    tr_TR: 'BD Sayısı',
    pt_BR: 'Quantidade de BD',
    id_ID: 'Jumlah BD',
    ru_RU: 'Количество BD',
    uz_UZ: 'BD soni',
    fa_IR: 'تعداد BD',
    ur_PK: 'BD کی تعداد',
  },
  公会数量: {
    zh_CN: '公会数量',
    en_US: 'Agency Amount',
    ar_SA: 'عدد الوكالات',
    tr_TR: 'Ajans Sayısı',
    pt_BR: 'Quantidade de Agências',
    id_ID: 'Jumlah Agensi',
    ru_RU: 'Количество агентств',
    uz_UZ: 'Agentliklar soni',
    fa_IR: 'تعداد آژانس‌ها',
    ur_PK: 'ایجنسیوں کی تعداد',
  },
  'BD ID': {
    zh_CN: 'BD ID',
    en_US: 'BD ID',
    ar_SA: 'معرف BD',
    tr_TR: 'BD ID',
    pt_BR: 'ID do BD',
    id_ID: 'ID BD',
    ru_RU: 'BD ID',
    uz_UZ: 'BD ID',
    fa_IR: 'شناسه BD',
    ur_PK: 'BD ID',
  },
  BD中心: {
    zh_CN: 'BD中心',
    en_US: 'BD Center',
    ar_SA: 'مركز BD',
    tr_TR: 'BD Merkezi',
    pt_BR: 'Centro de BD',
    id_ID: 'Pusat BD',
    ru_RU: 'Центр BD',
    uz_UZ: 'BD markazi',
    fa_IR: 'مرکز BD',
    ur_PK: 'BD مرکز',
  },
  你的上级管理: {
    zh_CN: '你的上级管理',
    en_US: 'Your Superior Admin',
    ar_SA: 'إدارتك العليا',
    tr_TR: 'Üst Yönetiminiz',
    pt_BR: 'Sua Gestão Superior',
    id_ID: 'Manajemen Atas Anda',
    ru_RU: 'Ваше руководство',
    uz_UZ: 'Sizning yuqori rahbariyatingiz',
    fa_IR: 'مدیران بالادستی شما',
    ur_PK: 'آپ کی بالادست مینجمنٹ',
  },
  代理ID: {
    zh_CN: 'Seller ID',
    en_US: 'Agent ID',
    ar_SA: 'معرف الوكيل',
    tr_TR: "Temsilci ID'si",
    pt_BR: 'ID do Agente',
    id_ID: 'ID Agen',
    ru_RU: 'ID агента',
    uz_UZ: 'Agent ID',
    fa_IR: 'شناسه نماینده',
    ur_PK: 'ایجنٹ ID',
  },
  下级公会数据: {
    zh_CN: '下级公会数据',
    en_US: 'Sub Agency Data',
    ar_SA: 'بيانات الوكالات الفرعية',
    tr_TR: 'Alt Ajans Verileri',
    pt_BR: 'Dados de Agências Subordinadas',
    id_ID: 'Data Agensi Bawahan',
    ru_RU: 'Данные подчинённых агентств',
    uz_UZ: 'Quyi agentliklar maʼlumotlari',
    fa_IR: 'داده‌های آژانس‌های زیرمجموعه',
    ur_PK: 'زیریں ایجنسیوں کا ڈیٹا',
  },
  个人数据: {
    zh_CN: '个人数据',
    en_US: 'Personal',
    ar_SA: 'شخصي',
    tr_TR: 'Kişisel',
    pt_BR: 'Pessoal',
    id_ID: 'Pribadi',
    ru_RU: 'Личный',
    uz_UZ: 'Shaxsiy',
    fa_IR: 'شخصی',
    ur_PK: 'ذاتی',
  },
  BD: {
    zh_CN: 'BD',
    en_US: 'BD',
    ar_SA: 'BD',
    tr_TR: 'BD',
    pt_BR: 'BD',
    id_ID: 'BD',
    ru_RU: 'BD',
    uz_UZ: 'BD',
    fa_IR: 'BD',
    ur_PK: 'BD',
  },
  活跃主播数: {
    zh_CN: '活跃主播数',
    en_US: 'Active Hosts',
    ar_SA: 'المضيفون النشطون',
    tr_TR: 'Aktif Yayıncılar',
    pt_BR: 'Streamers Ativos',
    id_ID: 'Host Aktif',
    ru_RU: 'Активные ведущие',
    uz_UZ: 'Faol boshlovchilar',
    fa_IR: 'میزبانان فعال',
    ur_PK: 'فعال میزبان',
  },
  产出钻石总数: {
    zh_CN: '产出钻石总数',
    en_US: 'Total Diamonds Generated',
    ar_SA: 'إجمالي الماس الناتج',
    tr_TR: 'Üretilen Toplam Elmas',
    pt_BR: 'Total de Diamantes Gerados',
    id_ID: 'Total Berlian Dihasilkan',
    ru_RU: 'Всего сгенерировано алмазов',
    uz_UZ: 'Ishlab chiqarilgan jami olmoslar',
    fa_IR: 'مجموع الماس‌های تولید شده',
    ur_PK: 'کل ہیرے پیدا ہوئے',
  },
  编辑: {
    zh_CN: '编辑',
    en_US: 'Edit',
    ar_SA: 'تعديل',
    tr_TR: 'Düzenle',
    pt_BR: 'Editar',
    id_ID: 'Edit',
    ru_RU: 'Редактировать',
    uz_UZ: 'Tahrirlash',
    fa_IR: 'ویرایش',
    ur_PK: 'ترمیم کریں',
  },
  请再次确认您的上级管理为: {
    zh_CN: '请再次确认您的上级管理为',
    en_US: 'Please confirm again that your superior admin is',
    ar_SA: 'يرجى التأكيد مرة أخرى أن مديرك الأعلى هو',
    tr_TR: 'Lütfen üst yöneticinizin şu kişi olduğunu tekrar onaylayın',
    pt_BR: 'Por favor, confirme novamente se o seu gerente superior é',
    id_ID: 'Silakan konfirmasi lagi bahwa manajer atasan Anda adalah',
    ru_RU: 'Пожалуйста, подтвердите еще раз, что вашим руководителем является',
    uz_UZ: 'Iltimos, rahbaringiz kim ekanligini yana bir bor tasdiqlang',
    fa_IR: 'لطفاً دوباره تأیید کنید که مدیر ارشد شما',
    ur_PK: 'براہ کرم دوبارہ تصدیق کریں کہ آپ کا اعلیٰ مینیجر ہے',
  },
  代理: {
    zh_CN: '代理',
    en_US: 'Seller',
    ar_SA: 'الوكيل',
    tr_TR: 'Temsilci',
    pt_BR: 'Agente',
    id_ID: 'Agen',
    ru_RU: 'Агент',
    uz_UZ: 'Agent',
    fa_IR: 'نماینده',
    ur_PK: 'ایجنٹ',
  },
  我的金币: {
    zh_CN: '我的金币',
    en_US: 'My Coins',
    ar_SA: 'المعادن',
    tr_TR: 'Benim Miktar',
    pt_BR: 'Meus Moedas',
    id_ID: 'Uang Saya',
    ru_RU: 'Мои монеты',
    uz_UZ: 'Mening jami',
    fa_IR: 'موجودی من',
  },
  分配: {
    zh_CN: '分配',
    en_US: 'Distribute',
    ar_SA: 'توزيع',
    tr_TR: 'Dağıt',
    pt_BR: 'Distribuir',
    id_ID: 'Terdistribusi',
    ru_RU: 'Распределить',
    uz_UZ: 'Bajarish',
    fa_IR: 'توزیع',
  },
  充值: {
    zh_CN: '充值',
    en_US: 'Recharge',
    ar_SA: 'إعادة تسليم',
    tr_TR: 'Yenile',
    pt_BR: 'Recarregar',
    id_ID: 'Isi ulang',
    ru_RU: 'Переплатить',
    uz_UZ: 'Qaytadan olish',
    fa_IR: 'شارژ',
  },
  请输入转账用户ID: {
    zh_CN: '请输入转账用户ID',
    en_US: 'Enter the transfer user ID',
    ar_SA: 'أدخل معرف المستخدم الذي تريد إرسال التحويل',
    tr_TR: 'Transfer kullanıcı ID\'sini giriniz',
    pt_BR: 'Digite o ID do usuário para transferência',
    id_ID: 'Masukkan ID pengguna penerima transfer',
    ru_RU: 'Введите ID пользователя, которому нужно перевести средства',
    uz_UZ: 'Transfer uchun foydalanuvchi ID ni kiriting',
    fa_IR: 'شناسه کاربری انتقال را وارد کنید',
  },
  请输入用户ID: {
    zh_CN: '请输入用户ID',
    en_US: 'Enter the user ID',
    ar_SA: 'أدخل معرف المستخدم',
    tr_TR: 'Kullanıcı ID\'sini giriniz',
    pt_BR: 'Digite o ID do usuário',
    id_ID: 'Masukkan ID pengguna',
    ru_RU: 'Введите ID пользователя',
    uz_UZ: 'Foydalanuvchi ID ni kiriting',
    fa_IR: 'شناسه کاربری را وارد کنید',
  },
  '该ID不存在,请重新输入': {
    zh_CN: '该ID不存在,请重新输入',
    en_US: 'The ID does not exist, please re-enter',
    ar_SA: 'هذا الرقم غير موجود، يرجى إعادة إدخاله',
    tr_TR: 'Bu ID bulunmuyor, lütfen tekrar giriniz',
    pt_BR: 'O ID não existe, por favor insira novamente',
    id_ID: 'ID tidak ada, silakan masukkan kembali',
    ru_RU: 'Такого ID не существует, пожалуйста, введите заново',
    uz_UZ: 'ID mavjud emas, qayta kiriting',
    fa_IR: 'این شناسه وجود ندارد، لطفاً دوباره وارد کنید',
    ur_PK: 'این ID وجود نہیں ہے، دوبارہ ورود کریں',
  },
  请输入转账金额: {
    zh_CN: '请输入转账金额',
    en_US: 'Enter the transfer amount',
    ar_SA: 'أدخل مبلغ التحويل',
    tr_TR: 'Transfer miktarını giriniz',
    pt_BR: 'Digite o valor da transferência',
    id_ID: 'Masukkan jumlah transfer',
    ru_RU: 'Введите сумму перевода',
    uz_UZ: 'Transfer miqdori kiriting',
    ur_PK: 'انتقالی مقدار را وارد کریں',
  },
  请输入金额: {
    zh_CN: '请输入金额',
    en_US: 'Enter the amount',
    ar_SA: 'أدخل المبلغ',
    tr_TR: 'Miktarı giriniz',
    pt_BR: 'Digite o valor',
    id_ID: 'Masukkan jumlah',
    ru_RU: 'Введите сумму',
    uz_UZ: 'Miqdori kiriting',
    fa_IR: 'مبلغ را وارد کنید',
    ur_PK: 'مقدار را وارد کریں',
  },
  选择支付方式: {
    zh_CN: '选择支付方式',
    en_US: 'Select Payment Method',
    ar_SA: 'اختر طريقة الدفع',
    tr_TR: 'Ödeme Yöntemini Seçin',
    pt_BR: 'Selecione o Método de Pagamento',
    id_ID: 'Pilih Metode Pembayaran',
    ru_RU: 'Выберите способ оплаты',
    uz_UZ: "To'lov uslubi tanlang",
    fa_IR: 'انتخاب روش پرداخت',
    ur_PK: 'پرداختی را انتخاب کریں',
  },
  金币不足: {
    zh_CN: '金币不足',
    en_US: 'Insufficient Coins',
    ar_SA: 'المعادن غير كافية',
    tr_TR: 'Yetersiz Miktar',
    pt_BR: 'Moedas Insuficientes',
    id_ID: 'Jumlah Koin yang tidak cukup',
    ru_RU: 'Недостаточно монет',
    uz_UZ: 'Jami miqdori kamchilik',
    fa_IR: 'کیفیت کمتر از حد',
    ur_PK: 'کیفیت کمتر از حد',
  },
  转账成功: {
    zh_CN: '转账成功',
    en_US: 'Transfer Success',
    ar_SA: 'تحويل ناجح',
    tr_TR: 'Transfer Başarılı',
    pt_BR: 'Transferência Concluída',
    id_ID: 'Transfer Berhasil',
    ru_RU: 'Перевод успешно выполнен',
    uz_UZ: 'Transfer uchun muvaffaqiyatli',
    fa_IR: 'انتقال موفق',
    ur_PK: 'انتقال کامیاب',
  },
  '确认给该用户转账{{n}}金币吗':  {
    zh_CN: '确认给该用户转账{{n}}金币吗?',
    en_US: 'Confirm to transfer {{n}} coins to this user?',
    ar_SA: 'هل تريد تحويل {{n}} معادن إلى هذا المستخدم؟',
    tr_TR: '{{n}} koin transfer etmek istiyor musunuz?',
    pt_BR: 'Confirma para transferir {{n}} moedas para este usuário?',
    id_ID: 'Apakah Anda yakin ingin mengirim {{n}} koin kepada pengguna ini?',
    ru_RU: 'Подтвердите перевод на {{n}} монет пользователю?',
    uz_UZ: "{{n}} so'mlik transfer etishni tasdiqlang?",
    fa_IR: 'این کاربر را به {{n}} کیف پول انتقال کنید؟',
    ur_PK: 'اس صارف کو {{n}} سونے کے سکوں کی منتقلی کی تصدیق کریں؟',
  },
  '确认给该用户转账{{n}}代理金币吗': {
    zh_CN: '确认给该用户转账{{n}}代理金币吗?',
    en_US: 'Confirm transfer of {{n}} seller coins to this user?',
    ar_SA: 'هل تريد تحويل {{n}} معادن الوكيل إلى هذا المستخدم؟',
    tr_TR: '{{n}} arac koin transfer etmek istiyor musunuz?',
    pt_BR: 'Confirma transferência de {{n}} moedas do agente para este usuário?',
    id_ID: 'Apakah Anda yakin ingin mengirim {{n}} koin arsip kepada pengguna ini?',
    ru_RU: 'Подтвердите перевод на {{n}} монет агенту пользователю?',
    uz_UZ: "{{n}} agent pulni transfer etishni tasdiqlang?",
    fa_IR: 'این کاربر را به {{n}} کیف پول وکیل انتقال کنید؟',
    ur_PK: 'اس صارف کو {{n}} سونے کے سکوں کی وکیل کی منتقلی کی تصدیق کریں؟',
  },
  '此用户是你的二级代理，本次他会收到代理金币': {
    zh_CN: 'Tips:此用户是你的二级代理，本次他会收到代理金币',
    en_US:
      'Tips: This user is your Sub-seller. They will receive seller coins this time.',
    ar_SA: 'ملاحظة: هذا المستخدم هو وكيلك من المستوى الثاني. سيحصل على عملات الوكيل هذه المرة.',
    tr_TR: 'İpucu: Bu kullanıcı senin ikinci seviye aracı. Bu sefer aracı miktarları alacak.',
    pt_BR: 'Dicas: Este usuário é seu segundo agente. Eles receberão moedas do agente nesta vez.',
    id_ID: 'Tips: Pengguna ini adalah agen kedua Anda. Mereka hanya menerima uang arsip sekarang.',
    ru_RU: 'Подсказка: Этот пользователь - ваш второй уровень агента. Он получит агентские монеты в этот раз.',
    uz_UZ: "Qo'shimcha: Bu foydalanuvchi sizning ikkinchi arzda agent. Ushbu marta agentlar pulini olishi mumkin.",
    fa_IR: 'توصیه: این کاربر یکی از مدیران دوم شما می باشد. این بار آنها کیف پول های وکیل دریافت خواهد کرد.',
    ur_PK: 'توجہ: این صارف دوم سے کیف پول انتقال کرنے کی اجازت دیتے ہیں. این بار آن کیف پول وکیل کی کسی بھی کسی بھی ہوتا ہے.',
  },
  上级币商: {
    zh_CN: '上级币商',
    en_US: 'Superior seller',
    ar_SA: 'المتاجر العلوية',
    tr_TR: 'Üst seviye coin alimleri',
    pt_BR: 'Traders de moedas superiores',
    id_ID: 'Penjual coin atas',
    ru_RU: 'Вышеуровневые трейдеры',
    uz_UZ: 'Yuqori arzda pulni olish uchun',
    fa_IR: 'مدیران بالاتر',
    ur_PK: 'اعلی درجے کے سکے کے تاجر'
  },
  '您的订单正在处理中，请稍候': {
    zh_CN: '您的订单正在处理中，请稍候。',
    en_US: 'Your order is being processed, please wait.',
    ar_SA: 'تم تنفيذ طلبك، يرجى الانتظار.',
    tr_TR: 'Siparişiniz işleniyor, lütfen bekleyin.',
    pt_BR: 'Seu pedido está sendo processado, por favor aguarde.',
    id_ID: 'Pesanan Anda sedang diproses, mohon tunggu.',
    ru_RU: 'Ваш заказ обрабатывается, пожалуйста, подождите.',
    uz_UZ: 'Sizning buyurtmangiz olib ketdi, keyinroq urinib ko\'ring.',
    fa_IR: 'سفارش شما در حال پردازش می باشد، لطفا منتظر بمانید.',
    ur_PK: 'سیٹرنا کی کار کر دیا گیا، منتظر کرنے کے لئے ہے.'
  },
  代理金币账单: {
    zh_CN: '代理金币账单',
    en_US: 'Seller Coin Bill',
    ar_SA: 'فاتورة معادن الوكيل',
    tr_TR: 'Arac Gold Coin Fatura',
    pt_BR: 'Nota de Moedas do Agente',
    id_ID: 'Tagihan Koin Arsip',
    ru_RU: 'Счет агентского золота',
    uz_UZ: 'Agent Gold Coin Fatura',
    fa_IR: 'فاکتور معادن وکیل',
    ur_PK: 'وکیل کی سونے کے سکوں کی فاکتور'
  },
  '给该用户转账了{{n}}金币': {
    zh_CN: '给该用户转账了{{n}}金币',
    en_US: 'Transferred {{n}} coins to this user',
    ar_SA: 'تم تحويل {{n}} معادن إلى هذا المستخدم',
    tr_TR: '{{n}} koin transfer edildi',
    pt_BR: 'Transferiu {{n}} moedas para este usuário',
    id_ID: 'Mengirim {{n}} koin kepada pengguna ini',
    ru_RU: 'Переведено {{n}} монет пользователю',
    uz_UZ: "{{n}} so'mlik transfer etildi",
    fa_IR: 'انتقال {{n}} کیف پول به این کاربر',
    ur_PK: 'انتقال {{n}} سونے کے سکوں کی صارف'
  },
  '收到上级币商的{{n}}代理金币': {
    zh_CN: '收到上级币商的{{n}}代理金币',
    en_US: 'Received {{n}} seller coins from the superior seller',
    ar_SA: 'تلقى {{n}} معادن طفل من المتاجر العلوية',
    tr_TR: '{{n}} arac gold coin alındı',
    pt_BR: 'Recebeu {{n}} moedas de ouro do agente superior', 
    id_ID: 'Menerima {{n}} koin emas dari penjual coin atas',
    ru_RU: 'Получено {{n}} монет агентского золота от вышеуровневого трейдера',
    uz_UZ: "{{n}} agent pulni olish uchun o'zingizga emas pulni olib ketdi",
    fa_IR: 'دریافت کردن {{n}} کیف پول وکیل از مدیران بالاتر',
    ur_PK: 'اعلی سکے کے تاجر سے {{n}} ایجنٹ سونے کے سکے موصول ہوئے۔',
  },
  '给该二级币商转账了{{n}}代理金币': {
    zh_CN: '给该二级币商转账了{{n}}代理金币',
    en_US: '{{n}} seller coins were transferred to the Sub-seller.',
    ar_SA: 'تم تحويل {{n}} معادن الوكيل إلى التاجر الثاني.',
    tr_TR: '{{n}} arac koinlar ikincil tedarikçe iletilmiştir.',
    pt_BR: '{{n}} moedas do agente foram transferidas para o dealer secundário.',
    id_ID: '{{n}} koin arsip dikirim kepada dealer lain.',
    ru_RU: 'Переведено {{n}} монет агенту вторичному дилеру.',
    uz_UZ: "{{n}} agent pulni ikkinchi tedarikchi bilan transfer etildi.",
    fa_IR: '{{n}} کیف پول وکیل به دیگر دارنده های ثانویه انتقال شد.',
    ur_PK: 'انتقال {{n}} سونے کے سکوں کی وکیل کی دیگر دارنده ہوئے۔',
  },
  确认: {
    zh_CN: '确认',
    en_US: 'Confirm',
    ar_SA: 'تأكيد',
    tr_TR: 'Onayla',
    pt_BR: 'Confirmar',
    id_ID: 'Konfirmasi',
    ru_RU: 'Подтвердить',
    uz_UZ: 'Tasdiqlash',
    fa_IR: 'تایید',
    ur_PK: 'تصدیق کریں'
  },
  复制成功: {
    zh_CN: '复制成功',
    en_US: 'Copied successfully',
    ar_SA: 'تم نسخ البيانات بنجاح',
    tr_TR: 'Veri kopyalandı',
    pt_BR: 'Dados copiados com sucesso',
    id_ID: 'Data disimpan',
    ru_RU: 'Данные скопированы',
    uz_UZ: 'Muvaffaqiyatli nusxa olindi',
    fa_IR: 'کپی شد',
    ur_PK: 'کپی شد'
  },
  // TODO 官网相关的
  国家和地区: {
    zh_CN: '国家 / 地区',
    en_US: 'Country / Region',
    ar_SA: 'الدولة / المنطقة',
    tr_TR: 'Ülke / Alan',
    pt_BR: 'País / Região',
    id_ID: 'Negara / Daerah',
    ru_RU: 'Страна / Регион',
    uz_UZ: 'Davlat / Resmi',
    fa_IR: 'کشور / مسیر',
    ur_PK: 'کشور / مسیر',
  },
  请输入: {
    zh_CN: '请输入',
    en_US: 'Enter',
    ar_SA: 'ادخل',
    tr_TR: 'Gir',
    pt_BR: 'Entrar',
    id_ID: 'Masukkan',
    ru_RU: 'Ввести',
    uz_UZ: 'Kiritish',
    fa_IR: ' وارد شد',
    ur_PK: 'اپ ہیں وارد کریں',
  },
  官网充值提示: {
    zh_CN: '请确认您输入的SouLike ID是正确的。',
    en_US: 'Please confirm that the SouLike ID you entered is correct. ',
    ar_SA: 'يرجى التأكد من أن معرف SouLike الذي أدخلته صحيح.',
    tr_TR: "Lütfen girdiğiniz SouLike ID'nin doğru olduğundan emin olun.",
    pt_BR: 'Por favor, confirme se o ID SouLike inserido está correto.',
    id_ID: 'Harap konfirmasi bahwa ID SouLike yang Anda masukkan benar.',
    ru_RU: 'Пожалуйста, убедитесь, что введенный вами SouLike ID верен.',
    uz_UZ: 'Iltimos, kiritilgan SouLike ID to‘g‘ri ekanligini tasdiqlang.',
    fa_IR: 'لطفاً تأیید کنید که شناسه SouLike وارد شده صحیح است.',
    ur_PK: 'براہ کرم تصدیق کریں کہ آپ کا درج کردہ SouLike ID درست ہے۔',
  },
  继续: {
    zh_CN: '继续',
    en_US: 'Continue',
    ar_SA: 'أمر',
    tr_TR: 'Devam et',
    pt_BR: 'Continuar',
    id_ID: 'Lanjutkan',
    ru_RU: 'Продолжить',
    uz_UZ: 'Kontinua',
    fa_IR: 'تایید',
    ur_PK: 'تایید',
  },
  更换: {
    zh_CN: '更换',
    en_US: 'Switch',
    ar_SA: 'Switch',
    tr_TR: 'Switch',
    pt_BR: 'Switch',
    id_ID: 'Switch',
    ru_RU: 'Смена',
    uz_UZ: 'Qaytarish',
    fa_IR: 'Switch',
    ur_PK: 'Switch',
  },
  支付方式: {
    en_US: 'Payment Method',
    ar_SA: 'طريقة الدفع',
    tr_TR: 'Ödeme Yöntemi',
    pt_BR: 'Método de Pagamento',
    id_ID: 'Metode Pembayaran',
    ru_RU: 'Способ оплаты',
    uz_UZ: 'To‘lov usuli',
    fa_IR: 'روش پرداخت',
    ur_PK: 'ادائیگی کا طریقہ',
    zh_CN: '支付方式',
  },
  充值金额: {
    en_US: 'Recharge Amount',
    ar_SA: 'مبلغ الشحن',
    tr_TR: 'Yükleme Tutarı',
    pt_BR: 'Valor de Recarga',
    id_ID: 'Jumlah Isi Ulang',
    ru_RU: 'Сумма пополнения',
    uz_UZ: 'To‘ldirish miqdori',
    fa_IR: 'مبلغ شارژ',
    ur_PK: 'ریچارج کی رقم',
    zh_CN: '充值金额',
  },
  官网首页标题: {
    zh_CN: '寻找你的灵魂伴侣',
    en_US: 'Find Your Soulmate',
    ar_SA: 'ابحث عن توأم روحك',
    tr_TR: 'Ruh Eşini Bul',
    pt_BR: 'Find Your Soulmate',
    id_ID: 'Find Your Soulmate',
    ru_RU: 'Найди свою вторую половинку',
    uz_UZ: "O'zingizning juftingizni toping",
    fa_IR: 'Find Your Soulmate',
    ur_PK: 'Find Your Soulmate',
  },
  官网首页描述: {
    zh_CN: '使用 Voice Club，您可以以简单可靠的方式与世界各地的人交谈并结交朋友。',
    en_US: 'Using Voice Club, you can talk and make friends with people all around the world, in simple and reliable way.',
    ar_SA: 'باستخدام Voice Club، يمكنك التحدث وتكوين صداقات مع أشخاص من جميع أنحاء العالم، بطريقة بسيطة وموثوقة.',
    tr_TR: "Voice Club'ı kullanarak, dünyanın her yerinden insanlarla basit ve güvenilir bir şekilde konuşabilir ve arkadaş olabilirsiniz.",
    pt_BR: 'Using Voice Club, you can talk and make friends with people all around the world, in simple and reliable way.',
    id_ID: 'Using Voice Club, you can talk and make friends with people all around the world, in simple and reliable way.',
    ru_RU: 'Используя Voice Club, вы можете общаться и заводить друзей с людьми со всего мира простым и надежным способом.',
    uz_UZ: "Voice Club yordamida butun dunyodagi odamlar bilan oddiy va ishonchli tarzda suhbatlashishingiz va do'stlashishingiz mumkin.",
    fa_IR: 'Using Voice Club, you can talk and make friends with people all around the world, in simple and reliable way.',
    ur_PK: 'Using Voice Club, you can talk and make friends with people all around the world, in simple and reliable way.',
  },
  官网首页谷歌标题: {
    zh_CN: 'GET IT ON',
    en_US: 'GET IT ON',
    ar_SA: 'احصل عليه من',
    tr_TR: 'ŞURADAN ALIN:',
    pt_BR: 'GET IT ON',
    id_ID: 'GET IT ON',
    ru_RU: 'ДОСТУПНО В',
    uz_UZ: 'YUKLAB OLISH:',
    fa_IR: 'GET IT ON',
    ur_PK: 'GET IT ON',
  },
  下载: {
    zh_CN: '下载',
    en_US: 'Download',
    ar_SA: 'تنزيل',
    tr_TR: 'İndir',
    pt_BR: 'Download',
    id_ID: 'Download',
    ru_RU: 'Скачать',
    uz_UZ: 'Yuklab olish',
    fa_IR: 'Download',
    ur_PK: 'Download',
  },
  官网首页安卓标题: {
    zh_CN: '(.apk 文件)',
    en_US: '(.apk File)',
    ar_SA: '(ملف .apk)',
    tr_TR: '(.apk Dosyası)',
    pt_BR: '(.apk File)',
    id_ID: '(.apk File)',
    ru_RU: '(Файл .apk)',
    uz_UZ: '(.apk Fayl)',
    fa_IR: '(.apk File)',
    ur_PK: '(.apk File)',
  },
  服务协议: {
    zh_CN: '服务协议',
    en_US: 'Terms of Service',
    ar_SA: 'شروط الخدمة',
    tr_TR: 'Hizmet Şartları',
    pt_BR: 'Terms of Service',
    id_ID: 'Terms of Service',
    ru_RU: 'Условия обслуживания',
    uz_UZ: "Xizmat ko'rsatish shartlari",
    fa_IR: 'Terms of Service',
    ur_PK: 'Terms of Service',
  },
  隐私政策: {
    zh_CN: '隐私政策',
    en_US: 'Privacy Policy',
    ar_SA: 'سياسة الخصوصية',
    tr_TR: 'Gizlilik Politikası',
    pt_BR: 'Privacy Policy',
    id_ID: 'Privacy Policy',
    ru_RU: 'Политика конфиденциальности',
    uz_UZ: 'Maxfiylik siyosati',
    fa_IR: 'Privacy Policy',
    ur_PK: 'Privacy Policy',
  },
  赠送财富等级: {
    zh_CN: '赠送财富等级',
    en_US: 'Gifting Wealth Level',
    ar_SA: 'مستوى الأثر الموهوب',
    tr_TR: 'Hediye Günlük Gelir Seviyesi',
    pt_BR: 'Nível de Renda Presenteado',
    id_ID: 'Level Keuangan Hadiah',
    ru_RU: 'Уровень подаренных денежных средств',
    uz_UZ: "Sovg'a qilingan maliyet darajasi",
    fa_IR: 'سطح اقتصاد اهدایی',
    ur_PK: 'تحفہ اقتصادیات کی سطح',
  },
  赠送魅力等级: {
    zh_CN: '赠送魅力等级',
    en_US: 'Gifting Charm Level',
    ar_SA: 'مستوى الجمال الموهوب',
    tr_TR: 'Hediye Güzellik Seviyesi',
    pt_BR: 'Nível de Beleza Presenteado',
    id_ID: 'Level Keindahan Hadiah',
    ru_RU: 'Уровень подаренной внешности',
    uz_UZ: "Sovg'a qilingan ko'rsatish darajasi",
    fa_IR: 'سطح جمال اهدایی',
    ur_PK: 'تحفہ جمال کی سطح',
  },
  '接受方财富等级不能大于等于{{n}}': {
    zh_CN: '接受方财富等级不能大于等于{{n}}',
    en_US: "The recipient's wealth level cannot be greater than or equal to {{n}}",
    ar_SA: 'لا يمكن أن يكون مستوى ثروة المستلم أكبر من أو يساوي {{n}}',
    tr_TR: 'Alıcının günlük gelir seviyesi {{n}} değerinden büyük veya bu değere eşit olamaz',
    pt_BR: 'O nível de renda do destinatário não pode ser maior ou igual a {{n}}',
    id_ID: 'Level keuangan penerima tidak boleh lebih besar dari atau sama dengan {{n}}',
    ru_RU: 'Уровень денежных средств получателя не может быть больше или равен {{n}}',
    uz_UZ: 'Qabul qiluvchining maliyet darajasi {{n}} dan katta yoki unga teng boʻlishi mumkin emas',
    fa_IR: 'سطح اقتصاد گیرنده نمی‌تواند بزرگتر یا مساوی {{n}} باشد',
    ur_PK: 'وصول کنندہ کی اقتصادی سطح {{n}} سے زیادہ یا اس کے برابر نہیں ہوسکتی ہے',
  },
  '财富等级会提升到{{n}}级': {
    zh_CN: '财富等级会提升到{{n}}级',
    en_US: 'Wealth level will be increased to level {{n}}',
    ar_SA: 'سيرتفع مستوى الثروة إلى المستوى {{n}}',
    tr_TR: 'Günlük gelir seviyesi {{n}}. seviyeye yükselecek',
    pt_BR: 'O nível de renda será aumentado para o nível {{n}}',
    id_ID: 'Level keuangan akan ditingkatkan ke level {{n}}',
    ru_RU: 'Уровень денежных средств повысится до уровня {{n}}',
    uz_UZ: 'Maliyet darajasi {{n}}-darajagacha oshiriladi',
    fa_IR: 'سطح اقتصاد به سطح {{n}} ارتقا می‌یابد',
    ur_PK: 'اقتصادی سطح {{n}} تک بڑھ جائے گی',
  },
  赠送财富确认: {
    zh_CN: '确认要给该用户赠送财富等级吗?',
    en_US: 'Are you sure you want to gift wealth level to this user?',
    ar_SA: 'هل أنت متأكد أنك تريد إهداء مستوى الثروة لهذا المستخدم؟',
    tr_TR: 'Bu kullanıcıya günlük gelir seviyesi hediye etmek istediğinizden emin misiniz?',
    pt_BR: 'Tem certeza de que deseja presentear o nível de renda a este usuário?',
    id_ID: 'Apakah Anda yakin ingin memberikan level keuangan kepada pengguna ini?',
    ru_RU: 'Вы уверены, что хотите подарить уровень денежных средств этому пользователю?',
    uz_UZ: 'Ushbu foydalanuvchiga maliyet darajasini sovgʻa qilmoqchi ekanligingizga ishonchingiz komilmi?',
    fa_IR: 'آیا مطمئن هستید که می‌خواهید سطح اقتصاد را به این کاربر اهدا کنید؟',
    ur_PK: 'کیا آپ واقعی اس صارف کو اقتصادی سطح تحفے میں دینا چاہتے ہیں؟',
  },
  '接受方魅力等级不能大于等于{{n}}': {
    zh_CN: '接受方魅力等级不能大于等于{{n}}',
    en_US: "The recipient's charm level cannot be greater than or equal to {{n}}",
    ar_SA: 'لا يمكن أن يكون مستوى السحر للمستلم أكبر من أو يساوي {{n}}',
    tr_TR: 'Alıcının güzellik seviyesi {{n}} değerinden büyük veya bu değere eşit olamaz',
    pt_BR: 'O nível de beleza do destinatário não pode ser maior ou igual a {{n}}',
    id_ID: 'Level keindahan penerima tidak boleh lebih besar dari atau sama dengan {{n}}',
    ru_RU: 'Уровень внешности получателя не может быть больше или равен {{n}}',
    uz_UZ: 'Qabul qiluvchining koʻrsatish darajasi {{n}} dan katta yoki unga teng boʻlishi mumkin emas',
    fa_IR: 'سطح جمال گیرنده نمی‌تواند بزرگتر یا مساوی {{n}} باشد',
    ur_PK: 'وصول کنندہ کی جمال کی سطح {{n}} سے زیادہ یا اس کے برابر نہیں ہوسکتی ہے',
  },
  '魅力等级会提升到{{n}}级': {
    zh_CN: '魅力等级会提升到{{n}}级',
    en_US: 'Charm level will be increased to level {{n}}',
    ar_SA: 'سيرتفع مستوى السحر إلى المستوى {{n}}',
    tr_TR: 'Güzellik seviyesi {{n}}. seviyeye yükselecek',
    pt_BR: 'O nível de beleza será aumentado para o nível {{n}}',
    id_ID: 'Level keindahan akan ditingkatkan ke level {{n}}',
    ru_RU: 'Уровень внешности повысится до уровня {{n}}',
    uz_UZ: 'Koʻrsatish darajasi {{n}}-darajagacha oshiriladi',
    fa_IR: 'سطح جمال به سطح {{n}} ارتقا می‌یابد',
    ur_PK: 'جمال کی سطح {{n}} تک بڑھ جائے گی',
  },
  赠送魅力确认: {
    zh_CN: '确认要给该用户赠送魅力等级吗?',
    en_US: 'Are you sure you want to gift charm level to this user?',
    ar_SA: 'هل أنت متأكد أنك تريد إهداء مستوى السحر لهذا المستخدم؟',
    tr_TR: 'Bu kullanıcıya güzellik seviyesi hediye etmek istediğinizden emin misiniz?',
    pt_BR: 'Tem certeza de que deseja presentear o nível de beleza a este usuário?',
    id_ID: 'Apakah Anda yakin ingin memberikan level keindahan kepada pengguna ini?',
    ru_RU: 'Вы уверены, что хотите подарить уровень внешности этому пользователю?',
    uz_UZ: 'Ushbu foydalanuvchiga koʻrsatish darajasini sovgʻa qilmoqchi ekanligingizga ishonchingiz komilmi?',
    fa_IR: 'آیا مطمئن هستید که می‌خواهید سطح جمال را به این کاربر اهدا کنید؟',
    ur_PK: 'کیا آپ واقعی اس صارف کو جمال کی سطح تحفے میں دینا چاہتے ہیں؟',
  },
  请输入目标用户ID: {
    zh_CN: '请输入目标用户ID',
    en_US: 'Please enter the target user ID',
    ar_SA: 'يرجى إدخال معرف المستخدم المستهدف',
    tr_TR: 'Lütfen hedef kullanıcı kimliğini girin',
    pt_BR: 'Por favor, insira o ID do usuário de destino',
    id_ID: 'Silakan masukkan ID pengguna target',
    ru_RU: 'Пожалуйста, введите ID целевого пользователя',
    uz_UZ: 'Iltimos, maqsadli foydalanuvchi ID-sini kiriting',
    fa_IR: 'لطفاً شناسه کاربر هدف را وارد کنید',
    ur_PK: 'براہ کرم ہدف صارف کی ID درج کریں',
  },
  请输入目标等级: {
    zh_CN: '请输入目标等级',
    en_US: 'Please enter the target level',
    ar_SA: 'يرجى إدخال المستوى المستهدف',
    tr_TR: 'Lütfen hedef seviyeyi girin',
    pt_BR: 'Por favor, insira o nível de destino',
    id_ID: 'Silakan masukkan level target',
    ru_RU: 'Пожалуйста, введите целевой уровень',
    uz_UZ: 'Iltimos, maqsadli darajani kiriting',
    fa_IR: 'لطفاً سطح هدف را وارد کنید',
    ur_PK: 'براہ کرم ہدف کی سطح درج کریں',
  },
  目标等级: {
    zh_CN: '目标等级',
    en_US: 'Target Level',
    ar_SA: 'المستوى المستهدف',
    tr_TR: 'Hedef Seviye',
    pt_BR: 'Nível de Destino',
    id_ID: 'Level Target',
    ru_RU: 'Целевой уровень',
    uz_UZ: 'Maqsadli daraja',
    fa_IR: 'سطح هدف',
    ur_PK: 'ہدف کی سطح',
  },
  赠送: {
    zh_CN: '赠送',
    en_US: 'Gift',
    ar_SA: 'إهداء',
    tr_TR: 'Hediye et',
    pt_BR: 'Presentear',
    id_ID: 'Hadiah',
    ru_RU: 'Подарить',
    uz_UZ: 'Sovgʻa',
    fa_IR: 'اهدا',
    ur_PK: 'تحفہ',
  },
  '财富等级提升至{{n}}': {
    zh_CN: '财富等级提升至{{n}}',
    en_US: 'Wealth level upgraded to {{n}}',
    ar_SA: 'ترقية مستوى الثروة إلى {{n}}',
    tr_TR: 'Günlük gelir seviyesi {{n}} seviyesine yükseltildi',
    pt_BR: 'Nível de renda atualizado para {{n}}',
    id_ID: 'Level keuangan ditingkatkan ke {{n}}',
    ru_RU: 'Уровень денежных средств повышен до {{n}}',
    uz_UZ: 'Maliyet darajasi {{n}} darajasiga koʻtarildi',
    fa_IR: 'سطح اقتصاد به {{n}} ارتقا یافت',
    ur_PK: 'اقتصادی سطح کو {{n}} تک اپ گریڈ کر دیا گیا',
  },
  '魅力等级提升至{{n}}': {
    zh_CN: '魅力等级提升至{{n}}',
    en_US: 'Charm level upgraded to {{n}}',
    ar_SA: 'ترقية مستوى الجمال إلى {{n}}',
    tr_TR: 'Güzellik seviyesi {{n}} seviyesine yükseltildi',
    pt_BR: 'Nível de beleza atualizado para {{n}}',
    id_ID: 'Level keindahan ditingkatkan ke {{n}}',
    ru_RU: 'Уровень внешности повышен до {{n}}',
    uz_UZ: 'Ko\'rsatish darajasi {{n}} darajasiga koʻtarildi',
    fa_IR: 'سطح جمال به {{n}} ارتقا یافت',
    ur_PK: 'جمال سطح کو {{n}} تک اپ گریڈ کر دیا گیا',
  },
  tips2: {
    en_US:
      "The seller has made the transfer, the actual receipt may be delayed for 1~2 hours, you can click on the ‘Not Arrived / Less Arrived’ below to file a complaint. After the seller confirms the transfer, orders that have not been confirmed will be automatically confirmed after x days.",
    ar_SA:
      "قام الوكيل بالتحويل، قد يتأخر الاستلام الفعلي لمدة 1-2 ساعة، يمكنك النقر على 'لم يصل/ وصل أقل' أدناه لتقديم شكوى. بعد تأكيد الوكيل للتحويل، سيتم تأكيد الطلبات غير المؤكدة تلقائيًا بعد x يوم.",
    tr_TR:
      "Satıcı transferi yaptı, gerçek makbuz 1-2 saat gecikebilir, şikayette bulunmak için aşağıdaki 'Gelmedi / Daha Az Geldi' seçeneğine tıklayabilirsiniz. Satıcı transferi onayladıktan sonra, onaylanmamış siparişler x gün sonra otomatik olarak onaylanacaktır.",
    ru_RU:
      "Продавец осуществил перевод, фактическое получение может задержаться на 1-2 часа. Вы можете нажать 'Не поступило/Поступило меньше' ниже, чтобы подать жалобу. После подтверждения перевода продавцом, неподтверждённые заказы будут автоматически подтверждены через x дней.",
    uz_UZ:
      "Sotuvchi pul o'tkazmasini amalga oshirdi, haqiqiy qabul qilish 1-2 soatga kechiktirilishi mumkin. Shikoyat qilish uchun quyidagi 'Kelmedi / Kamroq keldi' tugmasini bosing. Sotuvchi pul o'tkazmasini tasdiqlagandan so'ng, tasdiqlanmagan buyurtmalar x kundan keyin avtomatik ravishda tasdiqlanadi.",
    id_ID:
      "Penjual telah melakukan transfer, penerimaan sebenarnya mungkin tertunda 1-2 jam. Anda dapat mengklik 'Belum Tiba / Kurang Tiba' di bawah untuk mengajukan keluhan. Setelah penjual mengonfirmasi transfer, pesanan yang belum dikonfirmasi akan dikonfirmasi secara otomatis setelah x hari.",
    pt_BR:
      "O vendedor efetuou a transferência, o recibo real pode estar atrasado 1-2 horas. Pode clicar em 'Não Chegou / Chegou Menos' abaixo para apresentar uma reclamação. Após o vendedor confirmar a transferência, as encomendas não confirmadas serão confirmadas automaticamente após x dias.",
    fa_IR:
      "فروشنده انتقال را انجام داده است، دریافت واقعی ممکن است 1-2 ساعت تأخیر داشته باشد. شما می توانید بر روی 'نرسیده / کمتر رسیده' در زیر کلیک کنید تا شکایت ثبت کنید. پس از تأیید انتقال توسط فروشنده، سفارشات تأیید نشده پس از x روز به طور خودکار تأیید می شوند.",
    ur_PK:
      "فروش نے ٹرانسفر کر دیا ہے، اصل رسید میں 1-2 گھنٹے کی تاخیر ہو سکتی ہے۔ آپ شکایت درج کرنے کے لیے نیچے 'نہیں پہنچا / کم پہنچا' پر کلک کر سکتے ہیں۔ فروش کی طرف سے ٹرانسفر کی تصدیق کے بعد، غیر تصدیق شدہ آرڈرز x دنوں کے بعد خود بخود تصدیق ہو جائیں گے۔",
    es_ES:
      "El vendedor ha realizado la transferencia, la recepción real puede retrasarse 1-2 horas. Puede hacer clic en 'No llegó / Llegó menos' a continuación para presentar una queja. Después de que el vendedor confirme la transferencia, los pedidos no confirmados se confirmarán automáticamente después de x días.",
    th_TH: "ผู้ขายได้ทำการโอนเงินแล้ว การรับสินค้าอาจล่าช้าไป 1-2 ชั่วโมง คุณสามารถคลิกที่ ‘สินค้าไม่ได้รับ / สินค้าไม่ครบ’ ด้านล่างเพื่อแจ้งเรื่องร้องเรียนได้ เนื่องจากผู้ขายยืนยันการโอนเงินแล้ว คำสั่งซื้อที่ยังไม่ได้รับการยืนยันจะได้รับการยืนยันโดยอัตโนมัติหลังจากผ่านไป x วัน",
    vi_VN: 'Người bán đã chuyển tiền, việc nhận hàng thực tế có thể bị chậm trễ 1-2 giờ, bạn có thể nhấp vào ‘Chưa nhận được / Nhận được muộn’ bên dưới để khiếu nại. Sau khi người bán xác nhận chuyển khoản, các đơn hàng chưa được xác nhận sẽ tự động được xác nhận sau x ngày.'
  },
  tips3: {
    en_US:
      "After the user who is waiting for the withdrawal confirms that the withdrawal amount has reached the account, the order without confirmation will be automatically confirmed after x days from the date of the withdrawal request.",
    ar_SA:
      "في انتظار تأكيد مستخدم السحب على استلام مبلغ السحب. سيتم تأكيد الطلبات غير المؤكدة تلقائيًا بعد x أيام من بدء طلب السحب.",
    tr_TR:
      "Çekimi bekleyen kullanıcı çekim tutarının hesabına ulaştığını onayladıktan sonra, onay alınmadan verilen sipariş, tarihten itibaren x gün sonra otomatik olarak onaylanacaktır. ",
    ru_RU:
      "После того, как пользователь, ожидающий вывод, подтвердит получение суммы, не подтвержденный заказ будет автоматически подтвержден через x дней с даты подачи заявки на вывод.",
    uz_UZ:
      "Yechib olishni kutayotgan foydalanuvchi pul miqdori hisobga tushganligini tasdiqlagandan so‘ng, tasdiqlanmagan buyurtma yechib olish so‘rovi sanasidan boshlab x kundan keyin avtomatik ravishda tasdiqlanadi.",
    id_ID:
      "Setelah pengguna yang menunggu penarikan mengonfirmasi jumlah penarikan telah sampai ke akun, pesanan tanpa konfirmasi akan dikonfirmasi secara otomatis setelah x hari dari tanggal permintaan penarikan.",
    pt_BR:
      "Após o usuário que está aguardando a retirada confirmar que o valor da retirada chegou à conta, o pedido sem confirmação será confirmado automaticamente após x dias a partir da data do pedido de retirada.",
    fa_IR:
      "پس از اینکه کاربر در انتظار برداشت، وصول مبلغ برداشت را تأیید کرد، سفارش تأیید نشده به طور خودکار x روز پس از تاریخ درخواست برداشت تأیید خواهد شد.",
    ur_PK:
      "جب وہ صارف جو اپنی رقم کی وصولی کا انتظار کر رہا ہے یہ تصدیق کر دے کہ رقم اس کے اکاؤنٹ میں آگئی ہے، تو بغیر تصدیق کا آرڈر اُس تاریخ سے x دن بعد خود بخود تصدیق شدہ ہو جائے گا۔",
    es_ES:
      "Después de que el usuario que espera el retiro confirme que el monto del retiro ha llegado a la cuenta, el pedido sin confirmación se confirmará automáticamente después de x días desde la fecha de la solicitud de retiro.",
    vi_VN: 'Sau khi người dùng đang chờ rút tiền xác nhận rằng số tiền rút đã được chuyển vào tài khoản, lệnh rút tiền chưa được xác nhận sẽ tự động được xác nhận sau x ngày kể từ ngày yêu cầu rút tiền.',
    th_TH: "หลังจากผู้ใช้ที่รอการถอนเงินยืนยันว่าจำนวนเงินที่ถอนได้เข้าบัญชีแล้ว คำสั่งซื้อที่ยังไม่ได้รับการยืนยันจะได้รับการยืนยันโดยอัตโนมัติหลังจากผ่านไป x วันนับจากวันที่ส่งคำขอถอนเงิน" 
  },
  tips4: {
    en_US:
      "The fact that the payment has not been received has been reported to the seller. The actual payment may be delayed by 1 to 2 hours. If the payment has been received, please confirm receipt. The order after the agent confirms the transfer will be automatically confirmed after 7 days.",
    ar_SA:
      "لقد تم الإبلاغ للوكيل عن عدم استلام الدفعة. قد يتأخر الدفع الفعلي لمدة تتراوح من ساعة إلى ساعتين. إذا تم استلام الدفع، يرجى تأكيد الاستلام. سيتم تأكيد الطلب تلقائيًا بعد 7 أيام من تأكيد الوكيل للتحويل.",
    tr_TR:
      "Ödemenin alınmadığı acenteye bildirildi. Gerçek ödeme 1-2 saat gecikebilir. Ödemeniz alındıysa lütfen makbuzu onaylayın. Siparişiniz, acentenin transferi onaylamasından itibaren 7 gün sonra otomatik olيرة onaylanacaktır.",
    ru_RU:
      "Факт неполучения платежа был сообщен агенту. Фактический платеж может быть задержан на 1-2 часа. Если платеж получен, пожалуйста, подтвердите получение. Заказ будет автоматически подтвержден через 7 дней после подтверждения перевода агентом.",
    uz_UZ:
      "To‘lov qilinmaganligi agentga xabar qilindi. Haqiqiy to‘lov 1-2 soatga kechikishi mumkin. To‘lov qabul qilingan bo‘lsa, iltimos, qabul qilishni tasdiqlang. Agent pul o‘tkazmasini tasdiqlagandan so‘ng, buyurtma 7 kundan keyin avtomatik ravishda tasdiqlanadi.",
    id_ID:
      "Fakta bahwa pembayaran belum diterima telah dilaporkan kepada agen. Pembayaran sebenarnya mungkin tertunda 1-2 jam. Jika pembayaran sudah diterima, silakan konfirmasi penerimaannya. Pesanan akan dikonfirmasi secara otomatis setelah 7 hari setelah agen mengonfirmasi transfer.",
    pt_BR:
      "O facto de o pagamento não ter sido recebido foi relatado ao agente. O pagamento real pode ser atrasado de 1 a 2 horas. Se o pagamento tiver sido recebido, confirme o recebimento. A encomenda será confirmada automaticamente após 7 dias após o agente confirmar a transferência.",
    fa_IR:
      "این واقعیت که پرداخت دریافت نشده است، به مامور گزارش شده است. پرداخت واقعی ممکن است 1-2 ساعت تأخیر داشته باشد. اگر پرداخت دریافت شده است، لطفاً دریافت را تأیید کنید. پس از تأیید انتقال توسط مامور، سفارش پس از 7 روز به طور خودکار تأیید می‌شود.",
    ur_PK:
      "ادائیگی کی عدم وصولی کی اطلاع ایجنٹ کو دے دی گئی ہے۔ اصل ادائیگی میں 1 سے 2 گھنٹے کی تاخیر ہو سکتی ہے۔ اگر ادائیگی موصول ہو گئی ہے، تو براہ کرم وصولی کی تصدیق کریں۔ ایجنٹ کی جانب سے ٹرانسفر کی تصدیق کے بعد آرڈر 7 دنوں میں خود بخود تصدیق شدہ ہو جائے گا۔",
    es_ES:
      "Se ha informado al agente de que el pago no se ha recibido. El pago real puede retrasarse de 1 a 2 horas. Si se ha recibido el pago, confirme el recibo. El pedido se confirmará automáticamente después de 7 días de que el agente confirme la transferencia.",
    th_TH: "ข้อเท็จจริงที่ว่ายังไม่ได้รับการชำระเงินได้ถูกแจ้งให้ตัวแทนทราบแล้ว การชำระเงินจริงอาจล่าช้าไป 1-2 ชั่วโมง หากได้รับการชำระเงินแล้ว โปรดยืนยันการรับเงิน คำสั่งซื้อจะได้รับการยืนยันโดยอัตโนมัติหลังจากตัวแทนยืนยันการโอนเงินแล้ว 7 วัน",
    vi_VN: "Việc chưa nhận được thanh toán đã được báo cáo cho đại lý. Việc thanh toán thực tế có thể bị chậm trễ từ 1 đến 2 giờ. Nếu đã nhận được thanh toán, vui lòng xác nhận. Đơn hàng sẽ được tự động xác nhận sau 7 ngày kể từ khi đại lý xác nhận chuyển khoản."
  },
  popTips: {
    en_US: "Are you sure you want to reject this withdrawal order?",
    ar_SA: "هل أنت متأكد من رفض طلب السحب هذا؟",
    tr_TR: "Bu para çekme siparişini reddetmek istediğinizden emin misiniz?",
    ru_RU: "Вы уверены, что хотите отклонить этот заказ на вывод?",
    uz_UZ: "Ushbu yechib olish buyurtmasini rad etishni xohlaysizmi?",
    id_ID: "Apakah Anda yakin ingin menolak pesanan penarikan ini?",
    pt_BR: "Tem a certeza de que deseja rejeitar esta ordem de retirada?",
    fa_IR: "آیا مطمئن هستید که می‌خواهید این سفارش برداشت را رد کنید؟",
    ur_PK: "کیا آپ واقعی اس منہ پھیرنے کے آرڈر کو مسترد کرنا چاہتے ہیں؟",
    es_ES: "¿Está seguro de que desea rechazar este pedido de retiro?",
    th_TH: "คุณแน่ใจหรือไม่ว่าต้องการปฏิเสธคำสั่งถอนเงินนี้?",
    vi_VN: "Bạn có chắc chắn muốn từ chối lệnh rút tiền này không?"
  },
  更多支付方式: {
    zh_CN: '更多支付方式',
    en_US: 'More Payment Methods',
    ar_SA: 'المزيد من طرق الدفع',
    tr_TR: 'Daha Fazla Ödeme Yöntemi',
    pt_BR: 'Mais Métodos de Pagamento',
    id_ID: 'Metode Pembayaran Lainnya',
    ru_RU: 'Больше способов оплаты',
    uz_UZ: 'Koʻproq toʻlov usullari',
    fa_IR: 'روش‌های پرداخت بیشتر',
    ur_PK: 'مزید ادائیگی کے طریقے',
    th_TH: 'ช่องทางการชำระเงินเพิ่มเติม',
    vi_VN: 'Nhiều phương thức thanh toán hơn',
    es_ES: 'Más métodos de pago',
  },
  用户不存在: {
    zh_CN: '用户不存在',
    en_US: 'User does not exist',
    ar_SA: 'المستخدم غير موجود',
    tr_TR: 'Kullanıcı mevcut değil',
    pt_BR: 'Usuário não existe',
    id_ID: 'Pengguna tidak ada',
    ru_RU: 'Пользователь не существует',
    uz_UZ: 'Foydalanuvchi mavjud emas',
    fa_IR: 'کاربر وجود ندارد',
    ur_PK: 'صارف موجود نہیں ہے',
    th_TH: 'ไม่มีผู้ใช้นี้',
    vi_VN: 'Người dùng không tồn tại',
    es_ES: 'El usuario no existe',
  },
  充值介绍: {
    zh_CN: '充值介绍',
    en_US: 'Recharge Instructions',
    ar_SA: 'تعليمات الشحن',
    tr_TR: 'Yükleme Talimatları',
    pt_BR: 'Instruções de Recarga',
    id_ID: 'Instruksi Isi Ulang',
    ru_RU: 'Инструкции по пополнению',
    uz_UZ: 'Toʻldirish boʻyicha koʻrsatmalar',
    fa_IR: 'دستورالعمل‌های شارژ',
    ur_PK: 'ریچارج کی ہدایات',
    th_TH: 'คำแนะนำการเติมเงิน',
    vi_VN: 'Hướng dẫn nạp tiền',
    es_ES: 'Instrucciones de recarga',
  },
  充值描述1: {
    zh_CN: '1.充值前请输入您的Soulike ID。',
    en_US: '1.Enter your Soulike ID before starting recharge.',
    ar_SA: '1. أدخل معرف Soulike الخاص بك قبل بدء الشحن.',
    tr_TR: '1. Yükleme yapmadan önce Soulike ID\'nizi girin.',
    pt_BR: '1. Insira seu ID Soulike antes de iniciar a recarga.',
    id_ID: '1. Masukkan ID Soulike Anda sebelum memulai isi ulang.',
    ru_RU: '1. Введите свой ID Soulike перед началом пополнения.',
    uz_UZ: '1. Toʻldirishni boshlashdan oldin Soulike ID ni kiriting.',
    fa_IR: '1. قبل از شروع شارژ، شناسه Soulike خود را وارد کنید.',
    ur_PK: '1. ریچارج شروع کرنے سے پہلے اپنا Soulike ID درج کریں۔',
    th_TH: '1. กรอก Soulike ID ของคุณก่อนเริ่มการเติมเงิน',
    vi_VN: '1. Nhập ID Soulike của bạn trước khi bắt đầu nạp tiền.',
    es_ES: '1. Introduzca su ID de Soulike antes de iniciar la recarga.',
  },
  充值描述2: {
    zh_CN: '2.您可以在Soulike App的我的页面查看您的Soulike ID。',
    en_US: '2. You can check your Soulike ID in the page of Me in Soulike App.',
    ar_SA: '2. يمكنك التحقق من معرف Soulike الخاص بك في صفحة تطبيق Mein Soulike.',
    tr_TR: '2. Soulike ID\'nizi Mein Soulike Uygulamasının sayfasından kontrol edebilirsiniz.',
    pt_BR: '2. Você pode verificar seu ID Soulike na página do aplicativo Mein Soulike.',
    id_ID: '2. Anda dapat memeriksa ID Soulike Anda di halaman Aplikasi Mein Soulike.',
    ru_RU: '2. Вы можете проверить свой ID Soulike на странице приложения Mein Soulike.',
    uz_UZ: '2. Siz Soulike ID ni Mein Soulike ilovasi sahifasida tekshirishingiz mumkin.',
    fa_IR: '2. می‌توانید شناسه Soulike خود را در صفحه اپلیکیشن Mein Soulike بررسی کنید.',
    ur_PK: '2. آپ اپنا Soulike ID ، Mein Soulike ایپ کے صفحے میں دیکھ سکتے ہیں۔',
    th_TH: '2. คุณสามารถตรวจสอบ Soulike ID ของคุณได้ในหน้าแอป Mein Soulike',
    vi_VN: '2. Bạn có thể kiểm tra ID Soulike của mình trong trang Ứng dụng Mein Soulike.',
    es_ES: '2. Puede verificar su ID de Soulike en la página de la aplicación Mein Soulike.',
  },
  重新输入: {
    zh_CN: '重新输入',
    en_US: 'Re-enter',
    ar_SA: 'أعد الإدخال',
    tr_TR: 'Yeniden girin',
    pt_BR: 'Reentrar',
    id_ID: 'Masukkan ulang',
    ru_RU: 'Введите заново',
    uz_UZ: 'Qaytadan kiriting',
    fa_IR: 'دوباره وارد کنید',
    ur_PK: 'دوبارہ درج کریں',
    th_TH: 'ป้อนอีกครั้ง',
    vi_VN: 'Nhập lại',
    es_ES: 'Volver a introducir',
  },
  官方: {
    zh_CN: '官方',
    en_US: 'Official',
    ar_SA: 'رسمي',
    tr_TR: 'Resmi',
    pt_BR: 'Oficial',
    id_ID: 'Resmi',
    ru_RU: 'Официальный',
    uz_UZ: 'Rasmiy',
    fa_IR: 'رسمی',
    ur_PK: 'سرکاری',
    th_TH: 'เป็นทางการ',
    vi_VN: 'Chính thức',
    es_ES: 'Oficial',
  },
  支持所有国家: {
    zh_CN: '支持所有国家',
    en_US: 'Support for all countries',
    ar_SA: 'دعم لجميع الدول',
    tr_TR: 'Tüm ülkeler için destek',
    pt_BR: 'Suporte para todos os países',
    id_ID: 'Dukungan untuk semua negara',
    ru_RU: 'Поддержка для всех стран',
    uz_UZ: 'Barcha davlatlar uchun yordam',
    fa_IR: 'پشتیبانی از تمام کشورها',
    ur_PK: 'تمام ممالک کے لیے تعاون',
    th_TH: 'รองรับทุกประเทศ',
    vi_VN: 'Hỗ trợ cho tất cả các quốc gia',
    es_ES: 'Soporte para todos los países',
  },
  您可能会遇到的问题: {
    zh_CN: '您可能会遇到的问题：',
    en_US: 'Possible issues you may encounter:',
    ar_SA: 'المشكلات المحتملة التي قد تواجهها:',
    tr_TR: 'Karşılaşabileceğiniz olası sorunlar:',
    pt_BR: 'Possíveis problemas que você pode encontrar:',
    id_ID: 'Kemungkinan masalah yang mungkin Anda hadapi:',
    ru_RU: 'Возможные проблемы, с которыми вы можете столкнуться:',
    uz_UZ: 'Duch kelishingiz mumkin boʻlgan ehtimoliy muammolar:',
    fa_IR: 'مشکلات احتمالی که ممکن است با آن‌ها روبرو شوید:',
    ur_PK: 'ممکنہ مسائل جن کا آپ کو سامنا ہو سکتا ہے:',
    th_TH: 'ปัญหาที่เป็นไปได้ที่คุณอาจพบ:',
    vi_VN: 'Các vấn đề có thể bạn gặp phải:',
    es_ES: 'Posibles problemas que puede encontrar:',
  },
  第三方充值问题1: {
    zh_CN: '1.充值后如何查询账户是否到账？',
    en_US: '1. How to check if the account has received the funds after recharge?',
    ar_SA: '1. كيف تتحقق مما إذا كان الحساب قد تلقى الأموال بعد الشحن؟',
    tr_TR: '1. Yükleme işleminden sonra hesabın fonları alıp almadığı nasıl kontrol edilir?',
    pt_BR: '1. Como verificar se a conta recebeu os fundos após a recarga?',
    id_ID: '1. Bagaimana cara memeriksa apakah akun telah menerima dana setelah isi ulang?',
    ru_RU: '1. Как проверить, поступили ли средства на счет после пополнения?',
    uz_UZ: '1. Toʻldirishdan keyin hisobga mablagʻlar tushganligini qanday tekshirish mumkin?',
    fa_IR: '1. چگونه بررسی کنیم که آیا حساب پس از شارژ وجوه را دریافت کرده است؟',
    ur_PK: '1. ریچارج کے بعد کیسے چیک کریں کہ آیا اکاؤنٹ میں فنڈز موصول ہو گئے ہیں؟',
    th_TH: '1. จะตรวจสอบได้อย่างไรว่าบัญชีได้รับเงินหลังจากเติมเงินแล้ว?',
    vi_VN: '1. Làm thế nào để kiểm tra xem tài khoản đã nhận được tiền sau khi nạp chưa?',
    es_ES: '1. ¿Cómo comprobar si la cuenta ha recibido los fondos después de la recarga?',
  },
  第三方充值回答1: {
    zh_CN: '充值成功后，您可以返回App中的我的 - 钱包查看您的金币余额，此处充值的金币将实时到账。',
    en_US: 'After successful recharge, you can return to the App and go to Me - Wallet to check your coin balance. The coins recharged here will arrive in real time.',
    ar_SA: 'بعد الشحن الناجح، يمكنك العودة إلى التطبيق والذهاب إلى أنا - المحفظة للتحقق من رصيد العملات الخاص بك. ستصل العملات التي تم شحنها هنا في الوقت الفعلي.',
    tr_TR: 'Başarılı bir yükleme işleminden sonra, Uygulamaya dönebilir ve madeni para bakiyenizi kontrol etmek için Ben - Cüzdan\'a gidebilirsiniz. Burada yüklenen madeni paralar gerçek zamanlı olarak ulaşacaktır.',
    pt_BR: 'Após a recarga bem-sucedida, você pode retornar ao App e ir em Eu - Carteira para verificar seu saldo de moedas. As moedas recarregadas aqui chegarão em tempo real.',
    id_ID: 'Setelah isi ulang berhasil, Anda dapat kembali ke Aplikasi dan pergi ke Saya - Dompet untuk memeriksa saldo koin Anda. Koin yang diisi ulang di sini akan tiba secara real-time.',
    ru_RU: 'После успешного пополнения вы можете вернуться в приложение и перейти в раздел Я - Кошелек, чтобы проверить баланс монет. Монеты, пополненные здесь, поступят в реальном времени.',
    uz_UZ: 'Muvaffaqiyatli toʻldirishdan soʻng, siz Ilovaga qaytishingiz va tangalar balansini tekshirish uchun Men - Hamyon boʻlimiga oʻtishingiz mumkin. Bu yerda toʻldirilgan tangalar real vaqt rejimida kelib tushadi.',
    fa_IR: 'پس از شارژ موفق، می‌توانید به برنامه بازگردید و برای بررسی موجودی سکه‌های خود به من - کیف پول بروید. سکه‌های شارژ شده در اینجا به صورت درنگ‌حقیقی واریز می‌شوند.',
    ur_PK: 'کامیاب ریچارج کے بعد، آپ ایپ پر واپس جا سکتے ہیں اور اپنے سکے کے بیلنس کو چیک کرنے کے لیے میں - والیٹ پر جا سکتے ہیں۔ یہاں ریچارج کیے گئے سکے حقیقی وقت میں موصول ہوں گے۔',
    th_TH: 'หลังจากเติมเงินสำเร็จ คุณสามารถกลับไปที่แอปแล้วไปที่ ฉัน - กระเป๋าเงิน เพื่อตรวจสอบยอดเหรียญของคุณ เหรียญที่เติมที่นี่จะเข้าทันที',
    vi_VN: 'Sau khi nạp tiền thành công, bạn có thể quay lại Ứng dụng và đi đến Tôi - Ví để kiểm tra số dư xu của mình. Xu được nạp tại đây sẽ đến trong thời gian thực.',
    es_ES: 'Después de una recarga exitosa, puede volver a la aplicación e ir a Yo - Billetera para verificar su saldo de monedas. Las monedas recargadas aquí llegarán en tiempo real.',
  },
  第三方充值问题2: {
    zh_CN: '2.充值后账户没有收到币怎么办？',
    en_US: '2. What should I do if my account does not receive coins after recharge?',
    ar_SA: '2. ماذا أفعل إذا لم يتلق حسابي العملات بعد الشحن؟',
    tr_TR: '2. Yükleme işleminden sonra hesabıma madeni para gelmezse ne yapmalıyım?',
    pt_BR: '2. O que devo fazer se minha conta não receber moedas após a recarga?',
    id_ID: '2. Apa yang harus saya lakukan jika akun saya tidak menerima koin setelah isi ulang?',
    ru_RU: '2. Что делать, если на мой счет не поступили монеты после пополнения?',
    uz_UZ: '2. Toʻldirishdan keyin hisobimga tangalar kelib tushmasa nima qilishim kerak?',
    fa_IR: '2. اگر حساب من پس از شارژ سکه دریافت نکرد، چه باید بکنم؟',
    ur_PK: '2. اگر ریچارج کے بعد میرے اکاؤنٹ میں سکے موصول نہ ہوں تو مجھے کیا کرنا چاہیے؟',
    th_TH: '2. ฉันควรทำอย่างไรหากบัญชีของฉันไม่ได้รับเหรียญหลังจากการเติมเงิน?',
    vi_VN: '2. Tôi nên làm gì nếu tài khoản của mình không nhận được xu sau khi nạp tiền?',
    es_ES: '2. ¿Qué debo hacer si mi cuenta no recibe monedas después de la recarga?',
  },
  第三方充值回答2: {
    zh_CN: '请联系以下的号码联系平台客服并提供必要的信息，我们的客服将尽快协助你解决问题。',
    en_US: 'Please contact platform customer service at the numbers below and provide the necessary information. Our customer service will assist you in resolving the issue as soon as possible.',
    ar_SA: 'يرجى الاتصال بخدمة عملاء المنصة على الأرقام أدناه وتقديم المعلومات اللازمة. ستساعدك خدمة العملاء لدينا في حل المشكلة في أقرب وقت ممكن.',
    tr_TR: 'Lütfen aşağıdaki numaralardan platform müşteri hizmetleri ile iletişime geçin ve gerekli bilgileri sağlayın. Müşteri hizmetlerimiz sorunu en kısa sürede çözmenize yardımcı olacaktır.',
    pt_BR: 'Por favor, entre em contato com o atendimento ao cliente da plataforma nos números abaixo e forneça as informações necessárias. Nosso atendimento ao cliente o ajudará a resolver o problema o mais rápido possível.',
    id_ID: 'Silakan hubungi layanan pelanggan platform di nomor di bawah ini dan berikan informasi yang diperlukan. Layanan pelanggan kami akan membantu Anda menyelesaikan masalah secepat mungkin.',
    ru_RU: 'Пожалуйста, свяжитесь со службой поддержки платформы по указанным ниже номерам и предоставьте необходимую информацию. Наша служба поддержки поможет вам решить проблему как можно скорее.',
    uz_UZ: 'Iltimos, quyidagi raqamlar orqali platforma mijozlarni qoʻllab-quvvatlash xizmati bilan bogʻlaning va kerakli maʼlumotlarni taqdim eting. Bizning mijozlarni qoʻllab-quvvatlash xizmatimiz muammoni imkon qadar tezroq hal qilishda yordam beradi.',
    fa_IR: 'لطفاً با شماره‌های زیر با پشتیبانی مشتریان پلتفرم تماس بگیرید و اطلاعات لازم را ارائه دهید. پشتیبانی مشتریان ما در اسرع وقت به شما در حل مشکل کمک خواهد کرد.',
    ur_PK: 'براہ کرم نیچے دیے گئے نمبرز پر پلیٹ فارم کسٹمر سروس سے رابطہ کریں اور ضروری معلومات فراہم کریں۔ ہماری کسٹمر سروس جلد از جلد مسئلہ حل کرنے میں آپ کی مدد کرے گی۔',
    th_TH: 'โปรดติดต่อฝ่ายบริการลูกค้าของแพลตฟอร์มตามหมายเลขด้านล่างและให้ข้อมูลที่จำเป็น ฝ่ายบริการลูกค้าของเราจะช่วยเหลือคุณในการแก้ไขปัญหาโดยเร็วที่สุด',
    vi_VN: 'Vui lòng liên hệ dịch vụ khách hàng của nền tảng theo các số bên dưới và cung cấp thông tin cần thiết. Dịch vụ khách hàng của chúng tôi sẽ hỗ trợ bạn giải quyết vấn đề sớm nhất có thể.',
    es_ES: 'Póngase en contacto con el servicio de atención al cliente de la plataforma en los números a continuación y proporcione la información necesaria. Nuestro servicio de atención al cliente le ayudará a resolver el problema lo antes posible.',
  },
  第三方充值问题3: {
    zh_CN: '3.充值错误怎么办？',
    en_US: '3. What should I do if there is a recharge error?',
    ar_SA: '3. ماذا أفعل إذا كان هناك خطأ في الشحن؟',
    tr_TR: '3. Bir yükleme hatası olursa ne yapmalıyım?',
    pt_BR: '3. O que devo fazer se houver um erro de recarga?',
    id_ID: '3. Apa yang harus saya lakukan jika ada kesalahan isi ulang?',
    ru_RU: '3. Что делать, если произошла ошибка при пополнении?',
    uz_UZ: '3. Toʻldirishda xatolik yuz bersa nima qilishim kerak?',
    fa_IR: '3. در صورت بروز خطای شارژ چه باید بکنم؟',
    ur_PK: '3. اگر ریچارج میں غلطی ہو جائے تو مجھے کیا کرنا چاہیے؟',
    th_TH: '3. ฉันควรทำอย่างไรหากมีข้อผิดพลาดในการเติมเงิน?',
    vi_VN: '3. Tôi nên làm gì nếu có lỗi nạp tiền?',
    es_ES: '3. ¿Qué debo hacer si hay un error de recarga?',
  },
  第三方充值回答3: {
    zh_CN: '请联系以下的号码联系平台客服并提供必要的信息，我们的客服将尽快协助你解决问题。',
    en_US: 'Please contact platform customer service at the numbers below and provide the necessary information. Our customer service will assist you in resolving the issue as soon as possible.',
    ar_SA: 'يرجى الاتصال بخدمة عملاء المنصة على الأرقام أدناه وتقديم المعلومات اللازمة. ستساعدك خدمة العملاء لدينا في حل المشكلة في أقرب وقت ممكن.',
    tr_TR: 'Lütfen aşağıdaki numaralardan platform müşteri hizmetleri ile iletişime geçin ve gerekli bilgileri sağlayın. Müşteri hizmetlerimiz sorunu en kısa sürede çözmenize yardımcı olacaktır.',
    pt_BR: 'Por favor, entre em contato com o atendimento ao cliente da plataforma nos números abaixo e forneça as informações necessárias. Nosso atendimento ao cliente o ajudará a resolver o problema o mais rápido possível.',
    id_ID: 'Silakan hubungi layanan pelanggan platform di nomor di bawah ini dan berikan informasi yang diperlukan. Layanan pelanggan kami akan membantu Anda menyelesaikan masalah secepat mungkin.',
    ru_RU: 'Пожалуйста, свяжитесь со службой поддержки платформы по указанным ниже номерам и предоставьте необходимую информацию. Наша служба поддержки поможет вам решить проблему как можно скорее.',
    uz_UZ: 'Iltimos, quyidagi raqamlar orqali platforma mijozlarni qoʻllab-quvvatlash xizmati bilan bogʻlaning va kerakli maʼlumotlarni taqdim eting. Bizning mijozlarni qoʻllab-quvvatlash xizmatimiz muammoni imkon qadar tezroq hal qilishda yordam beradi.',
    fa_IR: 'لطفاً با شماره‌های زیر با پشتیبانی مشتریان پلتفرم تماس بگیرید و اطلاعات لازم را ارائه دهید. پشتیبانی مشتریان ما در اسرع وقت به شما در حل مشکل کمک خواهد کرد.',
    ur_PK: 'براہ کرم نیچے دیے گئے نمبرز پر پلیٹ فارم کسٹمر سروس سے رابطہ کریں اور ضروری معلومات فراہم کریں۔ ہماری کسٹمر سروس جلد از جلد مسئلہ حل کرنے میں آپ کی مدد کرے گی۔',
    th_TH: 'โปรดติดต่อฝ่ายบริการลูกค้าของแพลตฟอร์มตามหมายเลขด้านล่างและให้ข้อมูลที่จำเป็น ฝ่ายบริการลูกค้าของเราจะช่วยเหลือคุณในการแก้ไขปัญหาโดยเร็วที่สุด',
    vi_VN: 'Vui lòng liên hệ dịch vụ khách hàng của nền tảng theo các số bên dưới và cung cấp thông tin cần thiết. Dịch vụ khách hàng của chúng tôi sẽ hỗ trợ bạn giải quyết vấn đề sớm nhất có thể.',
    es_ES: 'Póngase en contacto con el servicio de atención al cliente de la plataforma en los números a continuación y proporcione la información necesaria. Nuestro servicio de atención al cliente le ayudará a resolver el problema lo antes posible.',
  },
    请先添加提现账户: {
    en_US: "Please add a withdrawal account first.",
    ar_SA: "يرجى إضافة حساب سحب أولاً.",
    tr_TR: "Lütfen önce bir para çekme hesabı ekleyin.",
    ru_RU: "Пожалуйста, сначала добавьте счет для вывода.",
    uz_UZ: "Iltimos, avval yechib olish hisobini qo'shing.",
    id_ID: "Silakan tambahkan akun penarikan terlebih dahulu.",
    pt_BR: "Por favor, adicione uma conta de retirada primeiro.",
    fa_IR: "لطفاً ابتدا یک حساب برداشت اضافه کنید.",
    ur_PK: "براہ کرم پہلے ایک واپسی اکاؤنٹ شامل کریں۔",
    es_ES: "Por favor, añada primero una cuenta de retiro.",
    th_TH: "กรุณาเพิ่มบัญชีถอนเงินก่อน",
    vi_VN: "Vui lòng thêm tài khoản rút tiền trước."
  },
  选择代理: {
    en_US: "Select Seller",
    ar_SA: "اختر الوكيل",
    tr_TR: "Acenta Seçin",
    ru_RU: "Выбрать агента",
    uz_UZ: "Agentni tanlang",
    id_ID: "Pilih Agen",
    pt_BR: "Selecionar Agente",
    fa_IR: "انتخاب مامور",
    ur_PK: "ایجنٹ منتخب کریں",
    es_ES: "Seleccionar Agente",
    th_TH: "เลือกตัวแทน",
    vi_VN: "Chọn đại lý"
  },
  请选择代理: {
    en_US: "Please select a seller",
    ar_SA: "يرجى تحديد وكيل",
    tr_TR: "Lütfen bir acenta seçin",
    ru_RU: "Пожалуйста, выберите агента",
    uz_UZ: "Iltimos, agentni tanlang",
    id_ID: "Silakan pilih agen",
    pt_BR: "Por favor, selecione um agente",
    fa_IR: "لطفاً یک مامور انتخاب کنید",
    ur_PK: "براہ کرم ایک ایجنٹ منتخب کریں",
    es_ES: "Por favor, seleccione un agente",
    th_TH: "กรุณาเลือกตัวแทน",
    vi_VN: "Vui lòng chọn đại lý"
  },
  请输入需要提款的金额: {
    en_US: "Please enter the amount to withdraw.",
    ar_SA: "يرجى إدخال مبلغ السحب.",
    tr_TR: "Lütfen çekilecek tutarı girin.",
    ru_RU: "Пожалуйста, введите сумму для вывода.",
    uz_UZ: "Iltimos, yechib olish miqdorini kiriting.",
    id_ID: "Silakan masukkan jumlah yang akan ditarik.",
    pt_BR: "Por favor, insira o valor a retirar.",
    fa_IR: "لطفاً مبلغ برداشت را وارد کنید.",
    ur_PK: "براہ کرم واپسی کی رقم درج کریں۔",
    es_ES: "Por favor, introduzca el importe a retirar.",
    th_TH: "กรุณาใส่จำนวนเงินที่ต้องการถอน",
    vi_VN: "Vui lòng nhập số tiền cần rút."
  },
  请选择提款方式: {
    en_US: "Please select a withdrawal method.",
    ar_SA: "يرجى اختيار طريقة السحب.",
    tr_TR: "Lütfen bir para çekme yöntemi seçin.",
    ru_RU: "Пожалуйста, выберите способ вывода.",
    uz_UZ: "Iltimos, yechib olish usulini tanlang.",
    id_ID: "Silakan pilih metode penarikan.",
    pt_BR: "Por favor, selecione um método de retirada.",
    fa_IR: "لطفاً یک روش برداشت انتخاب کنید.",
    ur_PK: "براہ کرم واپسی کا طریقہ منتخب کریں۔",
    es_ES: "Por favor, seleccione un método de retiro.",
    th_TH: "กรุณาเลือกวิธีถอนเงิน",
    vi_VN: "Vui lòng chọn phương thức rút tiền."
  },
  默认: {
    en_US: "Default",
    ar_SA: "افتراضي",
    tr_TR: "Varsayılan",
    ru_RU: "По умолчанию",
    uz_UZ: "Standart",
    id_ID: "Bawaan",
    pt_BR: "Padrão",
    fa_IR: "پیش‌فرض",
    ur_PK: "طے شدہ",
    es_ES: "Predeterminado",
    th_TH: "ค่าเริ่มต้น",
    vi_VN: "Mặc định"
  },
  我的钻石: {
    en_US: "My Diamonds",
    ar_SA: "أموالي الأمعاد",
    tr_TR: "Sizin Akçalarınız",
    ru_RU: "Ваши бриллианты",
    uz_UZ: "Sizning akkalariz",
    id_ID: "Diamant Saya",
    pt_BR: "Meus Diamantes",
    fa_IR: "می دامان من",
    ur_PK: "میں دیامان",
    es_ES: "Mis Diamantes",
    th_TH: "ดiamantของฉัน",
    vi_VN: "Diamant của tôi"
  },
    钻石余额: {
    en_US: "Diamond Balance",
    ar_SA: "رصيد الماس",
    tr_TR: "Elmas Bakiyesi",
    ru_RU: "Баланс бриллиантов",
    uz_UZ: "Olmos balansi",
    id_ID: "Saldo Berlian",
    pt_BR: "Saldo de Diamante",
    fa_IR: "موجودی الماس",
    ur_PK: "ہیرے کا بیلنس",
    es_ES: "Saldo de Diamantes",
    th_TH: "ยอดเพชร",
    vi_VN: "Số dư kim cương"
  },
  退出: {
    en_US: "Logout",
    ar_SA: "تسجيل الخروج",
    tr_TR: "Çıkış Yap",
    ru_RU: "Выйти",
    uz_UZ: "Chiqish",
    id_ID: "Keluar",
    pt_BR: "Sair",
    fa_IR: "خروج",
    ur_PK: "لاگ آؤٹ",
    es_ES: "Cerrar sesión",
    th_TH: "ออกจากระบบ",
    vi_VN: "Đăng xuất"
  },
  提现: {
    en_US: "Withdrawal",
    ar_SA: "سحب",
    tr_TR: "Çekme",
    ru_RU: "Вывод",
    uz_UZ: "Yechib olish",
    id_ID: "Penarikan",
    pt_BR: "Retirada",
    fa_IR: "برداشت",
    ur_PK: " واپسی",
    es_ES: "Retiro",
    th_TH: "ถอนเงิน",
    vi_VN: "Rút tiền"
  },
    请保留至少一种提现方式: {
    en_US: "Please keep at least one withdrawal method.",
    ar_SA: "يرجى الاحتفاظ بطريقة سحب واحدة على الأقل.",
    tr_TR: "Lütfen en az bir para çekme yöntemi tutun.",
    ru_RU: "Пожалуйста, оставьте хотя бы один способ вывода.",
    uz_UZ: "Iltimos, kamida bitta yechib olish usulini saqlang.",
    id_ID: "Harap pertahankan setidaknya satu metode penarikan.",
    pt_BR: "Por favor, mantenha pelo menos um método de retirada.",
    fa_IR: "لطفاً حداقل یک روش برداشت را نگه دارید.",
    ur_PK: "براہ کرم کم از کم ایک واپسی کا طریقہ برقرار رکھیں۔",
    es_ES: "Por favor, mantenga al menos un método de retiro.",
    th_TH: "กรุณาคงไว้อย่างน้อยหนึ่งวิธีการถอนเงิน",
    vi_VN: "Vui lòng giữ lại ít nhất một phương thức rút tiền."
  },
  确认删除该条提现方式: {
    zh_CN: "确认删除该条提现方式?",
    en_US: "Are you sure you want to delete this withdrawal method?",
    ar_SA: "هل أنت متأكد من أنك تريد حذف هذه طريقة السحب؟",
    tr_TR: "Bu para çekme yöntemiyle ilgili silme işlemini onaylıyor musunuz?",
    ru_RU: "Вы уверены, что хотите удалить этот способ вывода?",
    uz_UZ: "Bu yechib olish usulini o'chirmoqni tasdiqlashni xoxlaysizmi?",
    id_ID: "Apakah Anda yakin ingin menghapus metode penarikan ini?",
    pt_BR: "Tem certeza de que deseja excluir esta forma de retirada?",
    fa_IR: "آیا مطمئن هستید که می خواهید این روش برداشت را حذف کنید؟",
    ur_PK: "براہ کرم این واپسی کا طریقہ حذف کریں؟",
    es_ES: "¿Está seguro de que desea eliminar esta forma de retiro?",
    th_TH: "คุณแน่ใจหรือไม่ที่จะลบวิธีการถอนเงินนี้?",
    vi_VN: "Bạn có chắc chắn muốn xóa phương thức rút tiền này không?"
  },
    删除成功: {
    en_US: "Deleted successfully",
    ar_SA: "تم الحذف بنجاح",
    tr_TR: "Başarıyla silindi",
    ru_RU: "Успешно удалено",
    uz_UZ: "Muvaffaqiyatli o'chirildi",
    id_ID: "Berhasil dihapus",
    pt_BR: "Excluído com sucesso",
    fa_IR: "حذف موفق",
    ur_PK: "کامیابی سے حذف ہو گیا",
    es_ES: "Eliminado con éxito",
    th_TH: "ลบสำเร็จ",
    vi_VN: "Xóa thành công"
  },
  添加提现账户: {
    en_US: "Add Withdrawal Account",
    ar_SA: "إضافة حساب السحب",
    tr_TR: "Çekme Hesabı Ekle",
    ru_RU: "Добавить счет вывода",
    uz_UZ: "Yechib olish hisobini qo'shish",
    id_ID: "Tambah Akun Penarikan",
    pt_BR: "Adicionar Conta de Retirada",
    fa_IR: "افزودن حساب برداشت",
    ur_PK: "واپسی حساب کریں",
    es_ES: "Añadir Cuenta de Retiro",
    th_TH: "เพิ่มบัญชีการถอนเงิน",
    vi_VN: "Thêm tài khoản rút tiền"
  },
  提现方式: {
    en_US: "Withdrawal Method",
    ar_SA: "طريقة السحب",
    tr_TR: "Çekme Yöntemi",
    ru_RU: "Способ вывода",
    uz_UZ: "Yechib olish usuli",
    id_ID: "Metode Penarikan",
    pt_BR: "Método de Retirada",
    fa_IR: "روش برداشت",
    ur_PK: "واپسی کی طریقہ",
    es_ES: "Método de Retiro",
    th_TH: "วิธีการถอนเงิน",
    vi_VN: "Phương thức rút tiền"
  },
  删除: {
    en_US: "Delete",
    ar_SA: "حذف",
    tr_TR: "Sil",
    ru_RU: "Удалить",
    uz_UZ: "O'chirish",
    id_ID: "Hapus",
    pt_BR: "Excluir",
    fa_IR: "حذف",
    ur_PK: "حذف کریں",
    es_ES: "Eliminar",
    th_TH: "ลบ",
    vi_VN: "Xóa"
  },
  有内容未填写: {
    en_US: "Some content is not filled in.",
    ar_SA: "هناك محتوى غير مملوء.",
    tr_TR: "Bazı içerikler doldurulmamış.",
    ru_RU: "Некоторые поля не заполнены.",
    uz_UZ: "Ba'zi tarkiblar to'ldirilmagan.",
    id_ID: "Beberapa konten belum diisi.",
    pt_BR: "Algum conteúdo não foi preenchido.",
    fa_IR: "برخی محتوا پر نشده است.",
    ur_PK: "کچھ مواد درج نہیں کیا گیا۔",
    es_ES: "Falta contenido por rellenar.",
    th_TH: "มีเนื้อหาที่ยังไม่ได้รับการกรอก",
    vi_VN: "Có nội dung chưa được điền."
  },
  添加提款方式: {
    en_US: "Add withdrawal method",
    ar_SA: "إضافة طريقة سحب",
    tr_TR: "Para çekme yöntemi ekle",
    ru_RU: "Добавить способ вывода",
    uz_UZ: "Yechib olish usulini qo‘shish",
    id_ID: "Tambahkan Metode Penarikan",
    pt_BR: "Adicionar método de retirada",
    fa_IR: "افزودن روش برداشت",
    ur_PK: "منہ پھیرنے کا طریقہ شامل کریں",
    es_ES: "Añadir método de retiro",
    th_TH: "เพิ่มวิธีถอนเงิน",
    vi_VN: "Thêm phương thức rút tiền"
  },
  添加: {
    en_US: "Add",
    ar_SA: "إضافة",
    tr_TR: "Ekle",
    ru_RU: "Добавить",
    uz_UZ: "Qo'shish",
    id_ID: "Tambahkan",
    pt_BR: "Adicionar",
    fa_IR: "افزودن",
    ur_PK: "شامل کریں",
    es_ES: "Añadir",
    th_TH: "เพิ่ม",
    vi_VN: "Thêm"
  },
  提款方式: {
    en_US: "Withdrawal Method",
    ar_SA: "طريقة السحب",
    tr_TR: "Çekme Yöntemi",
    ru_RU: "Способ вывода",
    uz_UZ: "Yechib olish usuli",
    id_ID: "Metode Penarikan",
    pt_BR: "Método de Retirada",
    fa_IR: "روش برداشت",
    ur_PK: "واپسی کی طریقہ",
    es_ES: "Método de Retiro",
    th_TH: "วิธีการถอนเงิน",
    vi_VN: "Phương thức rút tiền"
  },
  请先选择币商: {
    en_US: "Please select a seller first",
    ar_SA: "الرجاء اختيار موزع أولاً",
    tr_TR: "Lütfen önce bir bayi seçin",
    ru_RU: "Сначала выберите реселлера",
    uz_UZ: "Iltimos, avval reseller tanlang",
    id_ID: "Harap pilih penjual terlebih dahulu",
    pt_BR: "Por favor, selecione um revendedor primeiro",
    fa_IR: "لطفا ابتدا یک فروشنده انتخاب کنید",
    ur_PK: "براہ کرم پہلے ایک ری سیلر منتخب کریں",
    es_ES: "Por favor, seleccione un revendedor primero",
    th_TH: "โปรดเลือกผู้ค้าปลีกก่อน",
    vi_VN: "Vui lòng chọn người bán lẻ trước"
  },
  单笔最少提取: {
    en_US: "Minimum amount each time",
    ar_SA: "الحد الأدنى للسحب في كل مرة",
    tr_TR: "Her seferinde minimum tutar",
    ru_RU: "Минимальная сумма за раз",
    uz_UZ: "Har safar minimal miqdor",
    id_ID: "Jumlah minimum per transaksi",
    pt_BR: "Valor mínimo por transação",
    fa_IR: "حداقل مبلغ در هر معامله",
    ur_PK: "ہر لین دین میں کم از کم رقم",
    es_ES: "Cantidad mínima por transacción",
    th_TH: "จำนวนขั้นต่ำต่อครั้ง",
    vi_VN: "Số tiền tối thiểu mỗi lần"
  },
    "提款申请发起成功，等待代理确认": {
    en_US:
      "Withdrawal request initiated successfully, waiting for seller to confirm",
    ar_SA: "تم بدء طلب السحب بنجاح، في انتظار تأكيد الوكيل",
    tr_TR: "Para çekme talebi başarıyla başlatıldı, satıcının onayı bekleniyor",
    ru_RU: "Запрос на вывод успешно отправлен, ожидайте подтверждения продавца",
    uz_UZ:
      "Yechib olish so‘rovi muvaffaqiyatli boshlandi, sotuvchidan tasdiqlash kutilmoqda",
    id_ID: "Permintaan penarikan berhasil dimulai, menunggu konfirmasi agen",
    pt_BR:
      "Pedido de retirada iniciado com sucesso, aguardando confirmação do vendedor",
    fa_IR: "درخواست برداشت با موفقیت آغاز شد، منتظر تأیید فروشنده",
    ur_PK:
      "منہ پھیرنے کی درخواست کامیابی سے شروع ہوئی، فروش کی تصدیق کا انتظار ہے",
    es_ES:
      "Solicitud de retiro iniciada con éxito, esperando confirmación del vendedor",
    th_TH: "ดำเนินการขอถอนเงินสำเร็จแล้ว กำลังรอการยืนยันจากเจ้าหน้าที่",
    vi_VN: "Yêu cầu rút tiền đã được khởi tạo thành công, đang chờ xác nhận từ nhân viên."
  },
    提款: {
    en_US: "Withdraw",
    ar_SA: "سحب",
    tr_TR: "Para Çek",
    ru_RU: "Вывести",
    uz_UZ: "Yechib ol",
    id_ID: "Tarik",
    pt_BR: "Sacar",
    fa_IR: "برداشت",
    ur_PK: "منہ پھیرو",
    es_ES: "Retirar",
    th_TH: "วิธีถอนเงิน",
    vi_VN: "Phương thức rút tiền"
  },
  提款金额: {
    en_US: "Withdrawal Amount",
    ar_SA: "مبلغ السحب",
    tr_TR: "Çekilecek Miktar",
    ru_RU: "Сумма вывода",
    uz_UZ: "Yechib olish miqdori",
    id_ID: "Jumlah Penarikan",
    pt_BR: "Valor de Retirada",
    fa_IR: "مقدار برداشت",
    ur_PK: "دفع کی مقدار",
    es_ES: "Cantidad de Retiro",
    th_TH: "จำนวนเงินที่ถอน",
    vi_VN: "Số tiền rút"
  },
    最大值: {
    en_US: "Maximum Amount",
    ar_SA: "الحد الأقصى",
    tr_TR: "Maksimum Tutar",
    ru_RU: "Максимальная сумма",
    uz_UZ: "Maksimal miqdor",
    id_ID: "Jumlah Maksimum",
    pt_BR: "Valor Máximo",
    fa_IR: "حداکثر مقدار",
    ur_PK: "زیادہ سے زیادہ رقم",
    es_ES: "Cantidad Máxima",
    th_TH: "จำนวนสูงสุด",
    vi_VN: "Số tiền tối đa"
  },
  最少提取: {
    en_US: "Minimum Withdraw",
    ar_SA: "الحد الأدنى للسحب",
    tr_TR: "Minimum Çekme",
    ru_RU: "Минимальный вывод",
    uz_UZ: "Minimal yechib olish",
    id_ID: "Jumlah Penarikan Minimum",
    pt_BR: "Valor Mínimo de Retirada",
    fa_IR: "حداقل برداشت",
    ur_PK: "کم از کم واپسی",
    es_ES: "Retiro Mínimo",
    th_TH: "จำนวนเงินที่ถอนน้อยสุด",
    vi_VN: "Số tiền rút tối thiểu"
  },
  最多提取: {
    en_US: "Maximum Withdraw",
    ar_SA: "الحد الأقصى للسحب",
    tr_TR: "Maksimum Çekme",
    ru_RU: "Максимальный вывод",
    uz_UZ: "Maksimal yechib olish",
    id_ID: "Jumlah Penarikan Maksimum",
    pt_BR: "Valor Máximo de Retirada",
    fa_IR: "حداکثر برداشت",
    ur_PK: "زیادہ سے زیادہ واپسی",
    es_ES: "Retiro Máximo",
    th_TH: "จำนวนเงินที่ถอนมากสุด",
    vi_VN: "Số tiền rút tối đa"
  },
  币商: {
    en_US: "Seller",
    ar_SA: "الموزع",
    tr_TR: "Bayi",
    ru_RU: "Реселлер",
    uz_UZ: "Reseller",
    id_ID: "Penjual",
    pt_BR: "Revendedor",
    fa_IR: "فروشنده",
    ur_PK: "ری سیلر",
    es_ES: "Revendedor",
    th_TH: "ผู้ค้าปลีก",
    vi_VN: "Người Bán Lẻ"
  },
  选择币商: {
    en_US: "Select Seller",
    ar_SA: "حدد موزع",
    tr_TR: "Bayi Seçin",
    ru_RU: "Выберите реселлера",
    uz_UZ: "Resellerni tanlang",
    id_ID: "Pilih Penjual",
    pt_BR: "Selecione Revendedor",
    fa_IR: "انتخاب فروشنده",
    ur_PK: "ری سیلر منتخب کریں",
    es_ES: "Seleccionar Revendedor",
    th_TH: "เลือกผู้ค้าปลีก",
    vi_VN: "Chọn người bán lẻ"
  },
  申请中: {
    en_US: "Applying",
    ar_SA: "قيد التقديم",
    tr_TR: "Başvuruda",
    ru_RU: "В процессе",
    uz_UZ: "Ariza berilmoqda",
    id_ID: "Sedang Diajukan",
    pt_BR: "Aplicando",
    fa_IR: "در حال درخواست",
    ur_PK: "درخواست دے رہا ہے۔",
    es_ES: "Solicitando",
    th_TH: "กำลังสมัคร",
    vi_VN: "Đang ứng tuyển",
  },
  进行中: {
    en_US: "In progress",
    ar_SA: "قيد التنفيذ",
    tr_TR: "Devam ediyor",
    ru_RU: "Выполняется",
    uz_UZ: "Jarayonda",
    id_ID: "Sedang Berlangsung",
    pt_BR: "Em andamento",
    fa_IR: "در حال انجام",
    ur_PK: "جاری ہے",
    es_ES: "En curso",
    th_TH: "กำลังดำเนินการ",
    vi_VN: "Đang tiến hành",
  },
  售后: {
    en_US: "After sale",
    ar_SA: "بعد البيع",
    tr_TR: "Satış sonrası",
    ru_RU: "После продажи",
    uz_UZ: "Sotishdan keyin",
    id_ID: "Setelah Penjualan",
    pt_BR: "Pós-venda",
    fa_IR: "پس از فروش",
    ur_PK: "فروخت کے بعد",
    es_ES: "Posventa",
    th_TH: "หลังการขาย",
    vi_VN: "Sau khi bán",
  },
  完成: {
    en_US: "Completed",
    ar_SA: "مكتمل",
    tr_TR: "Tamamlandı",
    ru_RU: "Завершено",
    uz_UZ: "Tugallandi",
    id_ID: "Selesai",
    pt_BR: "Concluído",
    fa_IR: "تکمیل شده",
    ur_PK: "مکمل",
    es_ES: "Completado",
    th_TH: "เสร็จสิ้น",
    vi_VN: "Hoàn thành",
  },
  提现订单: {
    en_US: "Withdrawal Order",
    ar_SA: "طلب السحب",
    tr_TR: "Para Çekme Siparişi",
    ru_RU: "Заказ на вывод",
    uz_UZ: "Yechib olish buyurtmasi",
    id_ID: "Pesanan Penarikan",
    pt_BR: "Ordem de Retirada",
    fa_IR: "سفارش برداشت",
    ur_PK: "واپسی کا آرڈر",
    es_ES: "Orden de Retiro",
    th_TH: "คำสั่งถอนเงิน",
    vi_VN: "Đơn rút tiền"
  },
  预计到账: {
    en_US: "Estimated arrival",
    ar_SA: "متوقع الوصول",
    tr_TR: "Tahmini varış",
    ru_RU: "Ориентировочное время поступления",
    uz_UZ: "Taxminiy kelish",
    id_ID: "Perkiraan tiba",
    pt_BR: "Chegada estimada",
    fa_IR: "زمان تخمینی وصول",
    ur_PK: "متوقع وصولی",
    es_ES: "Llegada estimada",
    th_TH: "เวลาที่คาดไว้",
    vi_VN: "Thời gian ước tính"
  },
  订单号: {
    en_US: "Order ID",
    ar_SA: "رقم الطلب",
    tr_TR: "Sipariş Numarası",
    ru_RU: "Номер заказа",
    uz_UZ: "Buyurtma raqami",
    id_ID: "Nomor Pesanan",
    pt_BR: "Número do Pedido",
    fa_IR: "شماره سفارش",
    ur_PK: "آرڈر نمبر",
    es_ES: "Número de Pedido",
    th_TH: "เลขที่คำสั่งซื้อ",
    vi_VN: "Mã đơn hàng"
  },
  提款订单完成时间: {
    en_US: "Withdrawal order completion time",
    ar_SA: "وقت إكمال طلب السحب",
    tr_TR: "Para çekme siparişi tamamlanma zamanı",
    ru_RU: "Время завершения заказа на вывод",
    uz_UZ: "Yechib olish buyurtmasini bajarish vaqti",
    id_ID: "Waktu penyelesaian pesanan penarikan",
    pt_BR: "Hora de conclusão da ordem de retirada",
    fa_IR: "زمان تکمیل سفارش برداشت",
    ur_PK: "منہ پھیرنے کے آرڈر کی تکمیل کا وقت",
    es_ES: "Hora de finalización del pedido de retiro",
    th_TH: "เวลาที่สำเร็จการทำรายการถอนเงิน",
    vi_VN: "Thời gian hoàn thành yêu cầu rút tiền",
  },
  原因: {
    en_US: "Reason",
    ar_SA: "السبب",
    tr_TR: "Sebep",
    ru_RU: "Причина",
    uz_UZ: "Sabab",
    id_ID: "Alasan",
    pt_BR: "Razão",
    fa_IR: "دلیل",
    ur_PK: "وجہ",
    es_ES: "Razón",
    th_TH: "เหตุผล",
    vi_VN: "Lý do"
  },
    联系: {
    en_US: "Contact",
    ar_SA: "اتصال",
    tr_TR: "İletişim",
    ru_RU: "Контакт",
    uz_UZ: "Aloqa",
    id_ID: "Kontak",
    pt_BR: "Contacto",
    fa_IR: "تماس",
    ur_PK: "رابطہ",
    es_ES: "Contacto",
    th_TH: "ติดต่อ",
    vi_VN: "Liên hệ"
  },
  汇款凭证: {
    en_US: "Remittance Voucher",
    ar_SA: "إثبات التحويل",
    tr_TR: "Havale Makbuzu",
    ru_RU: "Подтверждение перевода",
    uz_UZ: "O‘tkazma tasdiqnomasi",
    id_ID: "Bukti Transfer",
    pt_BR: "Comprovante de Remessa",
    fa_IR: "رسید انتقال وجه",
    ur_PK: "ادائیگی کی رسید",
    es_ES: "Comprobante de Remesa",
    th_TH: "หลักฐานการโอนเงิน",
    vi_VN: "Chứng từ chuyển khoản"
  },
  上传于: {
    en_US: "Uploaded on",
    ar_SA: "تم الرفع في",
    tr_TR: "Yükleme tarihi",
    ru_RU: "Загружено",
    uz_UZ: "Yuklangan sana",
    id_ID: "Diunggah pada",
    pt_BR: "Carregado em",
    fa_IR: "آپلود شده در",
    ur_PK: "اپ لوڈ ہونے کی تاریخ",
    es_ES: "Subido el",
    th_TH: "อัปโหลดเมื่อ",
    vi_VN: "Đã tải lên vào"
  },
    我收到了相应的工资: {
    en_US: "I have received the corresponding salary",
    ar_SA: "لقد تلقيت الراتب المقابل",
    tr_TR: "İlgili maaşı aldım",
    ru_RU: "Я получил соответствующую зарплату",
    uz_UZ: "Men tegishli maoshni oldim",
    id_ID: "Saya telah menerima gaji yang sesuai",
    pt_BR: "Recebi o salário correspondente",
    fa_IR: "من حقوق مربوطه را دریافت کرده‌ام",
    ur_PK: "مجھے متعلقہ اجرت موصول ہوئی ہے",
    es_ES: "He recibido el salario correspondiente",
    th_TH: "ฉันได้รับเงินเดือนที่เหมาะสม",
    vi_VN: "Tôi đã nhận được lương phù hợp",
  },
  我没有收到或收到的工资更少: {
    en_US: "I did not receive or received less salary",
    ar_SA: "لم أتلقى أو تلقيت راتبًا أقل",
    tr_TR: "Maaş almadım veya daha az aldım",
    ru_RU: "Я не получил или получил меньшую зарплату",
    uz_UZ: "Men maosh olmadim yoki kamroq oldim",
    id_ID: "Saya tidak menerima atau menerima gaji yang lebih sedikit",
    pt_BR: "Não recebi ou recebi menos salário",
    fa_IR: "من حقوق دریافت نکردم یا کمتر دریافت کردم",
    ur_PK: "مجھے اجرت نہیں ملی یا کم ملی",
    es_ES: "No recibí o recibí menos salario",
    th_TH: "ฉันไม่ได้รับเงินเดือนหรือได้รับเงินเดือนน้อยกว่า",
    vi_VN: "Tôi không nhận được hoặc nhận được mức lương ít hơn",
  },
  售后发起时间: {
    en_US: "After-sale initiation time",
    ar_SA: "وقت بدء ما بعد البيع",
    tr_TR: "Satış sonrası başlatma zamanı",
    ru_RU: "Время инициирования послепродажного обслуживания",
    uz_UZ: "Sotishdan keyingi xizmatni boshlash vaqti",
    id_ID: "Waktu inisiasi purna jual",
    pt_BR: "Hora de início pós-venda",
    fa_IR: "زمان شروع پس از فروش",
    ur_PK: "فروخت کے بعد آغاز کا وقت",
    es_ES: "Hora de inicio posventa",
    th_TH: "เวลาที่เริ่มต้นการดำเนินการต่อผลป้าย",
    vi_VN: "Thời gian bắt đầu hoàn thành đơn hàng sau bán hàng",
  },
  提交汇款凭证: {
    en_US: "Submit remittance voucher",
    ar_SA: "تقديم إثبات التحويل",
    tr_TR: "Havale makbuzunu gönder",
    ru_RU: "Отправить подтверждение перевода",
    uz_UZ: "O‘tkazma tasdiqnomasini yuborish",
    id_ID: "Kirimkan bukti transfer",
    pt_BR: "Enviar comprovante de remessa",
    fa_IR: "ارسال رسید انتقال وجه",
    ur_PK: "ادائیگی کی رسید جمع کروائیں",
    es_ES: "Enviar comprobante de remesa",
    th_TH: "ส่งหลักฐานการโอนเงิน",
    vi_VN: "Gửi chứng từ chuyển khoản",
  },
  请先上传凭证: {
    en_US: "Please upload the voucher first.",
    ar_SA: "يرجى تحميل الإثبات أولاً.",
    tr_TR: "Lütfen önce makbuzu yükleyin.",
    ru_RU: "Пожалуйста, сначала загрузите подтверждение.",
    uz_UZ: "Iltimos, avval tasdiqnomani yuklang.",
    id_ID: "Silakan unggah bukti terlebih dahulu.",
    pt_BR: "Por favor, faça o upload do comprovante primeiro.",
    fa_IR: "لطفاً ابتدا رسید را آپلود کنید.",
    ur_PK: "براہ کرم پہلے رسید اپ لوڈ کریں۔",
    es_ES: "Por favor, suba primero el comprobante.",
    th_TH: "กรุณาอัปโหลดบัตรยืนยันก่อน",
    vi_VN: "Vui lòng tải lên biên lai trước."
  },
  选择角色: {
    en_US: "Select Role",
    ar_SA: "حدد دور",
    tr_TR: "Rolü Seçin",
    ru_RU: "Выберите роль",
    uz_UZ: "Rolni tanlang",
    id_ID: "Pilih Peran",
    pt_BR: "Selecione o Cargo",
    fa_IR: "انتخاب نقش",
    ur_PK: "دور منتخب کریں",
    es_ES: "Seleccionar Rol",
    th_TH: "เลือกบทบาท",
    vi_VN: "Chọn vai trò"
  },
  主播: {
    en_US: "Hosts",
    ar_SA: "مضيف",
    tr_TR: "Yayıncılar",
    ru_RU: "Ведущие",
    uz_UZ: "Boshlovchilar",
    id_ID: "Pembawa Acara",
    pt_BR: "Anfitriões",
    fa_IR: "میزبانان",
    ur_PK: "میزبان",
    es_ES: "Anfitriones",
    th_TH: "ผู้ขายรายการ",
    vi_VN: "Người bán hàng"
  },
  确认已收到提现金额: {
    zh_CN: "确认已收到提现金额?",
    en_US: "Confirm that you have received the withdrawal amount?",
    ar_SA: "تأكيد أنك تلقى راتب التسديد؟",
    tr_TR: "Çekme miktarını aldığınızı onaylayın?",
    ru_RU: "Подтвердите, что вы получили сумму вывода?",
    uz_UZ: "Tashish summasini olishni tasdiqlashni tasdiqlang?",
    id_ID: "Konfirmasi bahwa Anda telah menerima jumlah penarikan?",
    pt_BR: "Confirme que você recebeu o valor da retirada?",
    fa_IR: "تایید کنید که مبلغ برداشت را دریافت کردید؟",
    ur_PK: "میں این مبلغ برداشت کی تکمیل کی ہوئی ہے؟",
    es_ES: "Confirme que ha recibido el monto de retiro?",
    th_TH: "ยืนยันว่าคุณได้รับเงินเดือนที่ถูกต้อง?",
    vi_VN: "Xác nhận rằng bạn đã nhận được số tiền rút tiền?"
  },
  确认没收到提现金额: {
    zh_CN: "确认没收到提现金额或金额不符？",
    en_US: "Confirm that you did not receive the withdrawal amount or the amount is not correct?",
    ar_SA: "تأكيد أنك لم تلقى راتب التسديد أو المبلغ غير صحيح؟",
    tr_TR: "Çekme miktarını aldığınızı veya miktar yanlış mı onaylayın?",
    ru_RU: "Подтвердите, что вы не получили сумму вывода или сумма не правильна?",
    uz_UZ: "Tashish summasini olishni qabul qilmoqda yoki summa to'g'ri emasmi tasdiqlang?",
    id_ID: "Konfirmasi bahwa Anda tidak menerima jumlah penarikan atau jumlah tidak tepat?",
    pt_BR: "Confirme se você não recebeu o valor da retirada ou se o valor está incorreto?",
    fa_IR: "تایید که مبلغ برداشت را دریافت نکردید یا مبلغ نادرست است؟",
    ur_PK: "میں این مبلغ برداشت کی تکمیل نہیں ہوئی ہے یا مبلغ نادرست ہے؟",
    es_ES: "Confirme que no ha recibido el monto de retiro o que el monto es incorrecto?",
    th_TH: "ยืนยันว่าคุณไม่ได้รับเงินเดือนหรือเงินเดือนไม่ถูกต้อง?",
    vi_VN: "Xác nhận rằng bạn không nhận được số tiền rút tiền hoặc số tiền không chính xác?"
  },
  超时拒绝: {
    zh_CN: "超时拒绝",
    en_US: "Timeout Rejection",
    ar_SA: "رفض م timed-out",
    tr_TR: "Timeout Rejection",
    ru_RU: "Отказ по таймауту",
    uz_UZ: "Timeout Rejection",
    id_ID: "Timeout Rejection",
    pt_BR: "Rejeição por Timeout",
    fa_IR: "ردیف به تایم آفی",
    ur_PK: "تایم آفی کے مبنی ردیف",
    es_ES: "Rechazo por Timeout",
    th_TH: "ปฏิเสธตามเวลาหมดอายุ",
    vi_VN: "Từ chối do thời gian hết hạn"
  },
  天: {
    zh_CN: '天',
    en_US: 'Days',
    ar_SA: 'أيام',
    tr_TR: 'Günler',
    ru_RU: 'Дни',
    uz_UZ: 'Kunlar',
    id_ID: 'Hari',
    pt_BR: 'Dias',
    fa_IR: 'روزها',
    ur_PK: 'دن',
    es_ES: 'Días',
    th_TH: 'วัน',
    vi_VN: 'Ngày'
  }
};


export default locales;